import { replaceImproperlyEncodedUnicodeCharacters } from '../catalog/helpers/url';

require('./block-ui.js');
require('./debounced-resize.js');
require('./match-heights.js');

// check to see if bootstrap3 already exists
var bootstrap3_enabled = (typeof $ == 'function' && typeof $().emulateTransitionEnd == 'function');
// check to see if boostrap collapse plugin exists
var bootstrapCollapse_enabled = (typeof $ == 'function' && typeof $.fn.collapse == 'function');

HawkSearch.Dictionary = (function () {
	function Dictionary() {
		if (!(this instanceof Dictionary))
			return new Dictionary();
	}

	Dictionary.prototype.count = function () {
		var key,
			count = 0;

		for (key in this) {
			if (this.hasOwnProperty(key))
				count += 1;
		}
		return count;
	};

	Dictionary.prototype.keys = function () {
		var key,
			keys = [];

		for (key in this) {
			if (this.hasOwnProperty(key))
				keys.push(key);
		}
		return keys;
	};

	Dictionary.prototype.values = function () {
		var key,
			values = [];

		for (key in this) {
			if (this.hasOwnProperty(key))
				values.push(this[key]);
		}
		return values;
	};

	Dictionary.prototype.keyValuePairs = function () {
		var key,
			keyValuePairs = [];

		for (key in this) {
			if (this.hasOwnProperty(key))
				keyValuePairs.push({
					Key: key,
					Value: this[key]
				});
		}
		return keyValuePairs;
	};

	Dictionary.prototype.add = function (key, value) {
		this[key] = value;
	}

	Dictionary.prototype.clear = function () {
		var key,
			dummy;

		for (key in this) {
			if (this.hasOwnProperty(key))
				dummy = delete this[key];
		}
	}

	Dictionary.prototype.containsKey = function (key) {
		return this.hasOwnProperty(key);
	}

	Dictionary.prototype.containsValue = function (value) {
		var key;

		for (key in this) {
			if (this.hasOwnProperty(key) && this[key] === value)
				return true;
		}
		return false;
	}

	Dictionary.prototype.remove = function (key) {
		var dummy;

		if (this.hasOwnProperty(key)) {
			dummy = delete this[key];
			return true;
		} else
			return false;
	}

	return Dictionary;
}());
HawkSearch.ContextObj = function () {
};
HawkSearch.ContextObj.prototype = new HawkSearch.Dictionary();
HawkSearch.ContextObj.prototype.Custom = new HawkSearch.Dictionary();
HawkSearch.Context = new HawkSearch.ContextObj();

(function (HawkSearchLoader, undefined) {
	var jQuery;

	//if true, HawkSearch's jQuery will be loaded dynamically in noConflict mode.
	HawkSearchLoader.loadjQuery = false;

	//if true, some messages will be sent to the console.
	HawkSearchLoader.debugMode = false;

	HawkSearch.SuggesterGlobal = {
		qf: '',
		lookupURL: '',
		divName: '',
		lastVal: '',
		searching: false,
		globalDiv: null,
		divFormatted: false,
		focus: false,
		defaultKeyword: []
	};


	HawkSearch.GetQueryStringValue = (function (a) {
		if (a == "") return {};
		var b = {};
		for (var i = 0; i < a.length; ++i) {
			var pair = a[i].split('=');
			if (pair.length != 2) continue;

			var name = pair[0];
			var value = replaceImproperlyEncodedUnicodeCharacters(pair[1]);

			b[name] = decodeURIComponent(value.replace(/\+/g, " "));
		}
		return b;
	})(window.location.search.substr(1).split('&'));

	HawkSearch.getTrackingUrl = function () {
		if (HawkSearch.TrackingUrl === undefined || HawkSearch.TrackingUrl === "") {
			return HawkSearch.BaseUrl;
		} else {
			return HawkSearch.TrackingUrl;
		}
	};

	HawkSearch.getHawkUrl = function () {
		if (HawkSearch.HawkUrl === undefined || HawkSearch.HawkUrl === "") {
			return HawkSearch.BaseUrl;
		} else {
			return HawkSearch.HawkUrl;
		}
	};

	HawkSearch.getClientGuid = function () {
		if (HawkSearch.ClientGuid !== undefined) {
			return HawkSearch.ClientGuid;
		} else {
			return '';
		}
	}

	HawkSearch.RecommendationContext = {
		visitId: "",
		visitorId: "",
		baseUrl: HawkSearch.getHawkUrl(),
		clientGuid: HawkSearch.getClientGuid(),
		enablePreview: false,
		widgetUids: [],
		contextProperties: [],
		customProperties: []
	};

	// and we can set up a data structure that contains information
	// that the server retrieved from long term storage to send
	// along with our clicks
	HawkSearch.EventBase = {
		version: '0.1a',
		event_type: 'PageLoad'
	};

	HawkSearch.Tracking = {}
	HawkSearch.Tracking.eventQueue = [];
	HawkSearch.Tracking.isReady = false;
	HawkSearch.Tracking.ready = function (callback) {
		if (HawkSearch.Tracking.isReady) {
			callback(HawkSearch.jQuery);
		} else {
			HawkSearch.Tracking.eventQueue.push(callback);
		}
	}

	HawkSearch.Tracking.setReady = function ($) {
		var callback;
		while (callback = HawkSearch.Tracking.eventQueue.shift()) {
			callback($);
		}
		HawkSearch.Tracking.isReady = true;
	}

	HawkSearch.Tracking.CurrentVersion = function () {
		return "v2";
	}

	HawkSearch.Tracking.Version = {
		none: "none",
		v1: "v1",
		v2: "v2",
		v2AndSQL: "v2AndSQL"
	}

	HawkSearch.Tracking.writePageLoad = function (pageType) {
		var callback = function () {
			if (pageType === undefined) {
				pageType = "";
			}

			var pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
			switch (pageType.toLowerCase()) {
				case "page":
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.landingPage;
					break;
				case "item":
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
					break;
				case "cart":
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.shoppingCart;
					break;
				case "order":
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.orderConfirmation;
					break;
				case "custom":
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.custom;
					break;
				default:
					pageTypeVal = HawkSearch.LilBro.Schema.PageLoad.PageType.itemDetails;
			}
			var trackingValues = null;
			if (trackingValues != null) {
				return;
			}
			log("Tracking: write page load");
			var trackingContextValues = null;
			if (HawkSearch.Context) {
				trackingContextValues = HawkSearch.Context.keyValuePairs()
			}
			if ((HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2) || (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2AndSql)) {
				HawkSearch.lilBro.write({
					event_type: 'PageLoad',
					tracking_properties: JSON.stringify(trackingContextValues),
					page_type_id: pageTypeVal
				});
			}
		}
		HawkSearch.Tracking.ready(callback);
	}


	HawkSearch.Tracking.writeSearchTracking = function (trackingId) {
		var callback = function (jQuery) {
			var $ = jQuery;

			if (trackingId == null || trackingId === "") {
				return;
			}

			var typeId = HawkSearch.LilBro.Schema.Search.SearchType["Refinement"];
			if ($("#hdnhawkquery").length === 0) {
				$('<input>').attr({
					type: 'hidden',
					id: 'hdnhawkquery',
					name: 'hdnhawkquery'
				}).appendTo('body');
				$("#hdnhawkquery").val(HawkSearch.lilBro.event.createUUID());
				typeId = HawkSearch.LilBro.Schema.Search.SearchType["Search"];
			}


			var mpp = HawkSearch.getHashOrQueryVariable("mpp");
			var pg = HawkSearch.getHashOrQueryVariable("pg");
			var sort = HawkSearch.getHashOrQueryVariable("sort");

			var spellingSuggestion = HawkSearch.getHashOrQueryVariable("hawks") === "1";
			var lpurl = HawkSearch.getCustomUrl();
			if (lpurl == "/") {
				lpurl = "";
			}

			log("Tracking: write search type" + typeId);
			HawkSearch.lilBro.write({
				event_type: 'Search',
				tracking_id: trackingId,
				query_id: $('#hdnhawkquery').val(),
				type_id: typeId,
				lpurl: lpurl
			});
		}
		HawkSearch.Tracking.ready(callback);
	}

	HawkSearch.Tracking.writeSearch = function () {
		var callback = function (jQuery) {
			var $ = jQuery;
			var trackingId = HawkSearch.lilBro.getTrackingId();
			if (trackingId == null) {
				return;
			}
			HawkSearch.Tracking.writeSearchTracking(trackingId);
		}
		HawkSearch.Tracking.ready(callback);
	}

	HawkSearch.Tracking.writeClick = function (event, elementNo, mlt, uniqueId, trackingId) {
		log("Tracking: write click");

		if (trackingId == null) {
			return;
		}

		var $ = $ || jQuery;
		var maxPerPage = $("#hdnhawkmpp").val();
		var pageNo = $("#hdnhawkpg").val();

		if (pageNo > 1) {
			elementNo = elementNo + maxPerPage * (pageNo - 1);
		}


		var url = event.currentTarget.href;
		var location = escape(event.currentTarget.href).replace(/\+/g, "%2B");
		HawkSearch.lilBro.write({
			url: url,
			event_type: 'Click',
			tracking_id: trackingId,
			element_no: elementNo,
			mlt: mlt === true,
			unique_id: uniqueId,
			location: location,
			ev: event
		});
	};

	HawkSearch.Tracking.writeBannerClick = function (el, id) {
		log("Tracking: banner click id:" + id);
		HawkSearch.lilBro.write({
			event_type: 'BannerClick',
			banner_id: id,
			tracking_id: HawkSearch.lilBro.getTrackingId()
		});
	}

	HawkSearch.Tracking.writeBannerImpression = function (id) {
		var callback = function () {
			log("Tracking: banner impression id:" + id);
			HawkSearch.lilBro.write({
				event_type: 'BannerImpression',
				banner_id: id,
				tracking_id: HawkSearch.lilBro.getTrackingId()
			});
		}

		HawkSearch.Tracking.ready(callback);
	};

	HawkSearch.Tracking.writeSale = function (orderNo, itemList, total, subTotal, tax, currency) {
		var callback = function () {
			log("Tracking: write sale");
			HawkSearch.lilBro.write({
				event_type: 'Sale',
				order_no: orderNo,
				item_list: JSON.stringify(itemList),
				total: total,
				tax: tax,
				currency: currency,
				sub_total: subTotal
			}, function () {
				HawkSearch.lilBro.event.clearVisitId();
				log("Tracking visit id clared after order.");
			});
		}
		HawkSearch.Tracking.ready(callback);
	};

	HawkSearch.Tracking.writeAdd2Cart = function (uniqueId, price, quantity, currency) {
		var callback = function () {
			log("Tracking: write Add2Cart");
			HawkSearch.lilBro.write({
				event_type: 'Add2Cart',
				unique_id: uniqueId,
				price: price,
				quantity: quantity,
				currency: currency
			});
		}

		HawkSearch.Tracking.ready(callback);
	}

	HawkSearch.Tracking.writeRate = function (uniqueId, value) {
		if (value < 1 || value > 5) {
			return;
		}
		var callback = function () {
			log("Tracking: write Rate");
			HawkSearch.lilBro.write({
				event_type: 'Rate',
				unique_id: uniqueId,
				value: value
			});
		}

		HawkSearch.Tracking.ready(callback);
	}


	HawkSearch.Tracking.writeRecommendationClick = function (widgetGuid, uniqueId, itemIndex, requestId) {
		var callback = function () {
			log("Tracking: write RecommendationClick");
			HawkSearch.lilBro.write({
				event_type: 'RecommendationClick',
				widget_guid: widgetGuid,
				unique_id: uniqueId,
				item_index: itemIndex,
				request_id: requestId
			});
		}
		HawkSearch.Tracking.ready(callback);
	}

	HawkSearch.Tracking.writeAutoCompleteClick = function (keyword, event, type, name, itemUrl) {
		log("AutoComplete: item click id:" + name);
		var $ = $ || jQuery;

		HawkSearch.lilBro.write({
			event_type: 'AutoCompleteClick',
			url: itemUrl,
			suggest_type: type,
			name: name,
			keyword: keyword
		});
	}

	HawkSearch.Tracking.track = function (eventName, args) {
		var ns = HawkSearch.Tracking;
		switch (eventName.toLowerCase()) {
			case 'pageload':
				return ns.writePageLoad(args.pageType);
			case 'search':
				return ns.writeSearch();
			case 'searchtracking':
				return ns.writeSearchTracking(args.trackingId);
			case 'click':
				return ns.writeClick(args.event, args.elementNo, args.mlt, args.uniqueId, args.trackingId);
			case 'bannerclick':
				return ns.writeBannerClick(args.el, args.id);
			case 'bannerimpression':
				return ns.writeBannerImpression(args.id);
			case 'sale':
				return ns.writeSale(args.orderNo, args.itemList, args.total, args.subTotal, args.tax, args.currency);
			case 'add2cart':
				return ns.writeAdd2Cart(args.uniqueId, args.price, args.quantity, args.currency);
			case 'rate':
				return ns.writeRate(args.uniqueId, args.value);
			case 'recommendationclick':
				return ns.writeRecommendationClick(args.widgetGuid, args.uniqueId, args.itemIndex, args.requestId);
			case 'autocompleteclick':
				return ns.writeAutoCompleteClick(args.keyword, args.event, args.suggest_type, args.name, args.itemUrl);
		}

		throw 'No such tracking event: ' + eventName;
	};

	HawkSearch.Tracking.V1 = {};

	HawkSearch.Tracking.V1.bannerLink = function (el, id) {
		el.href = HawkSearch.BaseUrl + '/banners.aspx?BannerId=' + id; el.mousedown = '';
		return true;
	};

	HawkSearch.Tracking.V1.autosuggestClick = function (keyword, name, url, type) {
		var args = '&keyword=' + encodeURIComponent(keyword) + '&name=' + encodeURIComponent(name) + '&type=' + type + '&url=' + encodeURIComponent(url);
		var getUrl = HawkSearch.BaseUrl + "?fn=ajax&f=GetAutoCompleteClick" + args;
		var $ = $ || jQuery;

		$.ajax({
			"type": "GET",
			"data": "",
			"async": "false",
			"contentType": "application/json; charset=utf-8",
			"url": getUrl,
			"dataType": "jsonp",
			success: function (data) {
				var json = typeof (data) === "object" ? data : JSON.parse(data);
				if (json.success === 'True') {
					log("success added tracking autocomplete click");
				}
				else {
					log("failed added tracking autocomplete click");
				}
			},
			error: function (error) {
				log(error);
			}
		});
	};

	HawkSearch.Tracking.V1.link = function (el, id, i, pk, mlt) {
		var full = HawkSearch.BaseUrl + "/link.aspx?id=" + escape(id) + "&q=" + escape(el.currentTarget.href).replace(/\+/g, "%2B") + "&i=" + i + "&pk=" + pk + "&mlt=" + mlt;
		el.currentTarget.href = full;
		return true;
	};

	// LilBro schemas
	HawkSearch.initLilBroSchema = function () {

		var root = HawkSearch;

		root.LilBro = root.LilBro || {
		};
		root.LilBro.Schema = {
		};

		root.LilBro.Schema.version = "default";

		root.LilBro.Schema.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			mouse_x: 6,
			mouse_y: 7,
			viewport_width: 8,
			viewport_height: 9,
			scroll_x: 10,
			scroll_y: 11,
			element_id: 12,
			element_id_from: 13,
			element_class: 14,
			element_class_from: 15,
			element_name: 16,
			element_tag: 17,
			element_type: 18,
			element_checked: 19,
			element_value: 20,
			element_x: 21,
			element_y: 22,
			browser: 23,
			browser_version: 24,
			operating_system: 25,
			request_path: 26,
			qs: 27,
			tracking_id: 28,
			unique_id: 29,
			element_no: 30,
			mlt: 31,
			keyword: 32,
			current_page: 33,
			max_per_page: 34,
			items_count: 35,
			sorting: 36,
			is_custom: 37
		};

		root.LilBro.Schema.type_map = {
			PageLoad: 1,
			Search: 2,
			Click: 3,
			Add2Cart: 4,
			Rate: 5,
			Sale: 6,
			BannerClick: 7,
			BannerImpression: 8,
			Login: 9,
			RecommendationClick: 10,
			AutoCompleteClick: 11
		};

		root.LilBro.Schema.PageLoad = {
		};
		root.LilBro.Schema.PageLoad.version = "pl01a";
		root.LilBro.Schema.PageLoad.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			viewport_width: 6,
			viewport_height: 7,
			browser: 8,
			browser_version: 9,
			operating_system: 10,
			request_path: 11,
			qs: 12,
			tracking_properties: 13,
			page_type_id: 14
		}
		root.LilBro.Schema.PageLoad.PageType = {
			itemDetails: 1,
			landingPage: 2,
			shoppingCart: 3,
			orderConfirmation: 4,
			custom: 5
		}

		root.LilBro.Schema.Search = {
		};
		root.LilBro.Schema.Search.version = "ref01a";
		root.LilBro.Schema.Search.SearchType = {
			Search: 1,
			Refinement: 2
		};

		root.LilBro.Schema.Search.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			viewport_width: 6,
			viewport_height: 7,
			browser: 8,
			browser_version: 9,
			operating_system: 10,
			request_path: 11,
			qs: 12,
			tracking_id: 13,
			query_id: 14,
			type_id: 15
		}

		root.LilBro.Schema.Click = {
		};
		root.LilBro.Schema.Click.version = "cli01a";
		root.LilBro.Schema.Click.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			mouse_x: 6,
			mouse_y: 7,
			viewport_width: 8,
			viewport_height: 9,
			scroll_x: 10,
			scroll_y: 11,
			element_id: 12,
			element_id_from: 13,
			element_class: 14,
			element_class_from: 15,
			element_name: 16,
			element_tag: 17,
			element_type: 18,
			element_checked: 19,
			element_value: 20,
			element_x: 21,
			element_y: 22,
			browser: 23,
			browser_version: 24,
			operating_system: 25,
			request_path: 26,
			qs: 27,
			tracking_id: 28,
			unique_id: 29,
			mlt: 30,
			element_no: 31,
			url: 32
		}

		root.LilBro.Schema.Rate = {
		};
		root.LilBro.Schema.Rate.version = "rat01a";
		root.LilBro.Schema.Rate.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			value: 6,
			unique_id: 7
		}

		root.LilBro.Schema.Sale = {
		};
		root.LilBro.Schema.Sale.version = "sal01a";
		root.LilBro.Schema.Sale.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			order_no: 6,
			item_list: 7,
			total: 8,
			tax: 9,
			currency: 10,
			sub_total: 11
		}

		root.LilBro.Schema.Add2Cart = {
		};
		root.LilBro.Schema.Add2Cart.version = "a2c01a";
		root.LilBro.Schema.Add2Cart.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			unique_id: 6,
			price: 7,
			quantity: 8,
			currency: 9
		}

		root.LilBro.Schema.BannerClick = {
		}
		root.LilBro.Schema.BannerClick.version = "banclk01a";
		root.LilBro.Schema.BannerClick.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			tracking_id: 6,
			banner_id: 7
		}

		root.LilBro.Schema.BannerImpression = {
		}
		root.LilBro.Schema.BannerImpression.version = "banimp01a";
		root.LilBro.Schema.BannerImpression.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			tracking_id: 6,
			banner_id: 7
		}



		root.LilBro.Schema.RecommendationClick = {
		}
		root.LilBro.Schema.RecommendationClick.version = "recClick01a";
		root.LilBro.Schema.RecommendationClick.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			widget_guid: 6,
			unique_id: 7,
			item_index: 8,
			request_id: 9
		}

		root.LilBro.Schema.AutoCompleteClick = {
		}
		root.LilBro.Schema.AutoCompleteClick.version = "autoComplClick01a";
		root.LilBro.Schema.AutoCompleteClick.key_map = {
			// leave slot 0 for the server timestamp
			version: 1,
			timestamp: 2,
			event_type: 3,
			visitor_id: 4,
			visit_id: 5,
			suggest_type: 6,
			url: 7,
			name: 8,
			keyword: 9
		}
		root.LilBro.Schema.AutoCompleteClick.AutoCompleteType = {
			popular: 1,
			category: 2,
			product: 3,
			content: 4
		}

	}

	// LilBro code
	HawkSearch.LilBro = function (args) {
		HawkSearch.initLilBroSchema();
		var self = this;
		var $ = null;

		this.initialize = function (args) {
			if (args) {
				if (!args.server) {
					return;
				}

				$ = args.jQuery;
				this.watch_container(args.element, args.watch_focus);

				this.freshEvent = function () {
					var base = {};
					if (args.event_base) {
						for (var p in args.event_base) {
							if (args.event_base.hasOwnProperty(p)) {
								base[p] = args.event_base[p];
							}
						}
					}

					var eventType = args.event_type || args.event_base.event_type || "PageLoad";
					return new HawkSearch.LilBro.Event({
						base: base,
						key_map: args.key_map || HawkSearch.LilBro.Schema[eventType].key_map || HawkSearch.LilBro.Schema.key_map,
						type_map: args.type_map || HawkSearch.LilBro.Schema.type_map,
						server: args.server,
						ssl_server: args.ssl_server,
						visit_id_cookie: args.visit_id_cookie || 'visit_id',
						visitor_id_cookie: args.visitor_id_cookie || 'visitor_id'
					});
				};
			} else {
				return;
			}

			try {
				if (sessionStorage && sessionStorage.getItem('lilbrobug' + window.location.protocol)) {
					var src = decodeURIComponent(sessionStorage.getItem('lilbrobug' + window.location.protocol));
					var bug = new Image();
					bug.onload = function () {
						sessionStorage.removeItem('lilbrobug' + window.location.protocol);
					};
					bug.src = src;
				}
			} catch (e) {
				log('ERROR: ' + e);
			}

			this.event = this.freshEvent();
			HawkSearch.RecommendationContext.visitorId = this.event.getVisitorId();
			HawkSearch.RecommendationContext.visitId = this.event.getVisitId();
		};

		this.watch_container = function (el, focus) {
			if (!el) {
				return;
			}
			if (el.addEventListener) {
				el.addEventListener('click', _doer_maker('click'), false);
				if (focus) {
					el.addEventListener('focusin', _doer_maker('focusin'), false);
					el.addEventListener('focusout', _doer_maker('focusout'), false);
				}
			} else {
				el.attachEvent('onclick', _doer_maker('click'), false);
				if (focus) {
					el.attachEvent('onfocusin', _doer_maker('focusin'), false);
					el.attachEvent('onfocusout', _doer_maker('focusout'), false);
				}
			}
		};

		this.watch = function (args) {
			if (!args) {
				return;
			}
			if (!args.element) {
				return;
			}
			if (args.element.addEventListener) {
				args.element.addEventListener(
					'click',
					_doer_maker('click', args.callback, args.bubble),
					false
				);
			} else {
				args.element.attachEvent(
					'onclick',
					_doer_maker('click', args.callback, args.bubble),
					false
				);
			}
		};

		function _doer_maker(type, callback, bubble) {
			return function (ev) {
				if (!ev) {
					ev = window.event;
				}
				var targ = self._findTarget(ev);
				self.event.fill({
					type: type,
					event: ev,
					target: targ
				});
				if (callback) {
					try {
						callback(self.event);
					} catch (e) {
					}
				}
				if (bubble != null && !bubble) {
					ev.cancelBubble = true;
					if (ev.stopPropagation) {
						ev.stopPropagation();
					}
				}
				self.event.write();
				self.event = self.freshEvent();
			};
		};

		this.createObjectProps = function (obj) {
			var key_map = obj._key_map;
			for (var key in key_map) {
				if (!obj._event.hasOwnProperty(key)) {
					obj._event[key] = "";
				}
			}
		};

		this.write = function (obj, callback) {
			var schema = HawkSearch.LilBro.Schema[obj.event_type];
			var key_map = args.key_map || schema.key_map;
			var version = schema.version || HawkSearch.LilBro.Schema.version;
			self.event._key_map = key_map;
			this.createObjectProps(self.event);
			var ev = obj.ev;
			if (!obj.ev && window.event) {
				ev = window.event;
			}
			var targ = self._findTarget(ev);
			self.event.fill({
				type: obj.event_type,
				event: ev,
				target: targ,
				version: version
			});

			for (var key in obj) {
				self.event.set(key, obj[key]);
			}

			self.event.write(callback);
			self.event = self.freshEvent();
		};

		// event target lifted from quirksmode
		this._findTarget = function (ev) {
			var targ = null;
			if (ev && ev.target) {
				targ = ev.target;
			} else if (ev && ev.srcElement) {
				targ = ev.srcElement;
			}
			// defeat Safari bug
			if (targ && targ.nodeType == 3) {
				targ = targ.parentNode;
			}
			return targ;
		};

		this.getTrackingId = function () {
			if ($("#hdnhawktrackingid").length == 0 || $("#hdnhawktrackingid").val() === "") {
				return null;
			}
			return $("#hdnhawktrackingid").val();
		};

		this.initialize(args);
	};

	HawkSearch.LilBro.Event = function (args) {

		this.initialize = function (args) {
			this._event = args.base;
			this._key_map = args.key_map;
			this._type_map = args.type_map;
			this.server = args.server;
			this.ssl_server = args.ssl_server;
			this.visit_id_cookie = args.visit_id_cookie;
			this.visitor_id_cookie = args.visitor_id_cookie;
		};

		this.set = function (prop, val) {
			if (!this._event.hasOwnProperty(prop)) {
				return;
			}
			return this._event[prop] = val;
		};

		this.get = function (prop) {
			return this._event[prop];
		};

		this.write = function (callback) {
			var isExpand = HawkSearch.GetQueryStringValue["expand"] !== undefined;
			if (isExpand) {
				return;
			}
			var event = [];
			var et = "";
			for (var key in this._key_map) {
				if (key === "event_type") {
					event[this._key_map[key]] = this._type_map[this.get(key)] || 0;
					et = event[this._key_map[key]];
				} else {
					event[this._key_map[key]] = this.get(key);
				}
			}
			var protocol = window.location.protocol;
			var customDictionaryString = JSON.stringify(HawkSearch.Context.Custom.keyValuePairs());
			var clientIdentifyToken;
			if (HawkSearch.getClientGuid() !== "") {
				clientIdentifyToken = '&cg=' + HawkSearch.getClientGuid();
			} else {
				clientIdentifyToken = '&bu=' + HawkSearch.getHawkUrl();
			}
			if ((HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2) || (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2AndSql)) {
				var src = HawkSearch.getTrackingUrl() + '/hawk.png?t=' + encodeURIComponent(btoa(event.join('\x01'))) + '&et=' + et + clientIdentifyToken + '&cd=' + encodeURIComponent(customDictionaryString) + '&' + this.randomHexBlocks(1);

				log(src);
				try {
					if (sessionStorage) {
						sessionStorage.setItem(
							'lilbrobug' + protocol,
							encodeURIComponent(src)
						);
					}
				} catch (e) {
					log('Tracking: ERROR ' + e);
				}

				var bug = new Image();
				bug.onload = function () {
					log("Tracking sent. " + src);
					try {
						sessionStorage.removeItem('lilbrobug' + protocol);
					} catch (e) {
						log('Tracking: ERROR ' + e);
					}
					if (callback) {
						callback();
					}
				};
				bug.src = src;
			}
		};

		this.fill
			= function (args) {
				//version
				if (args && args.version) {
					this.set('version', args.version);
				} else {
					this.set('version', HawkSearch.LilBro.Schema.version);
				}

				if (args && args.type) {
					// event type
					this.set('event_type', args.type);
				};
				if (args && args.event) {

					// mouse coordinates
					var mouse_x = '';
					var mouse_y = '';
					if (args.event.pageX || args.event.pageY) {
						mouse_x = args.event.pageX;
						mouse_y = args.event.pageY;
					} else if (args.event.clientX || args.event.clientY) {
						mouse_x = args.event.clientX + document.body.scrollLeft
							+ document.documentElement.scrollLeft;
						mouse_y = args.event.clientY + document.body.scrollTop
							+ document.documentElement.scrollTop;
					}
					this.set('mouse_x', mouse_x);
					this.set('mouse_y', mouse_y);
				}

				// viewport
				this.set('viewport_width', document.documentElement.clientWidth);
				this.set('viewport_height', document.documentElement.clientHeight);

				// scroll, snaked from http://webcodingeasy.com/Javascript/Get-scroll-position-of-webpage--crossbrowser
				var scroll_x = 0, scroll_y = 0;
				if (typeof (window.pageYOffset) == 'number') {
					scroll_x = window.pageXOffset;
					scroll_y = window.pageYOffset;
				} else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
					scroll_x = document.body.scrollLeft;
					scroll_y = document.body.scrollTop;
				} else if (document.documentElement && (document.documentElement.scrollLeft
					|| document.documentElement.scrollTop)) {
					scroll_x = document.documentElement.scrollLeft;
					scroll_y = document.documentElement.scrollTop;
				}
				this.set('scroll_x', scroll_x || 0);
				this.set('scroll_y', scroll_y || 0);

				// element goodies
				if (args && args.target) {
					// element id and class, or their closest ancestors
					var el_id = args.target.id;
					var el_class = args.target.className;
					var id_from_ancestor = !el_id;
					var class_from_ancestor = !el_class;
					var id_path, class_path;
					if (!el_id || !el_class) {
						var targ_orig = args.target;
						id_path = args.target.tagName;
						class_path = args.target.tagName;
						do {
							args.target = args.target.parentNode;
							if (args.target === null || args.target == undefined) {
								break;
							}
							if (!el_id && args.target.tagName) {
								id_path = args.target.tagName + '/' + id_path;
								el_id = args.target.id;
							}
							if (!el_class && args.target.tagName) {
								class_path = args.target.tagName + '/' + class_path;
								el_class = args.target.className;
							}
						} while ((!el_id || !el_class) && args.target.parentNode);
						args.target = targ_orig;
					}
					this.set('element_id', el_id);
					this.set('element_class', el_class);
					if (el_id && id_from_ancestor) {
						this.set('element_id_from', id_path);
					}
					if (el_class && class_from_ancestor) {
						this.set('element_class_from', class_path);
					}

					// element sundry
					this.set('element_name', args.target.name || '');
					this.set('element_tag', args.target.tagName || '');
					this.set('element_type', args.target.type || '');
					this.set('element_checked', args.target.checked ? 1 : '');
					// by default, ignore typed input
					if (args.target.type && args.target.type.toLowerCase() !== 'text'
						&& args.target.type.toLowerCase() !== 'password') {
						this.set('element_value', args.target.value || '');
					}

					// including the position best effort (http://stackoverflow.com/a/442474)
					var element_x = 0;
					var element_y = 0;
					var targ_orig = args.target;
					while (args.target && !isNaN(args.target.offsetLeft) && !isNaN(args.target.offsetTop)) {
						element_x += args.target.offsetLeft - args.target.scrollLeft;
						element_y += args.target.offsetTop - args.target.scrollTop;
						args.target = args.target.offsetParent;
					}
					args.target = targ_orig;
					this.set('element_x', element_x);
					this.set('element_y', element_y);
				}

				// browser
				if (HawkSearch.LilBro.BrowserDetect) {
					this.set('browser', HawkSearch.LilBro.BrowserDetect.browser);
					this.set('browser_version', HawkSearch.LilBro.BrowserDetect.version);
					this.set('operating_system', HawkSearch.LilBro.BrowserDetect.OS);
				}

				// path part of url
				this.set('request_path', window.location.pathname);

				// other client bits
				var d = new Date();
				this.set('timestamp', d.getTime());
				var visitorId = this.getVisitorId();
				var visitId = this.getVisitId();
				this.set('visitor_id', visitorId);
				this.set('visit_id', visitId);
				this.set('qs', encodeURIComponent(HawkSearch.getHash()));
			};

		this.getVisitorId = function () {
			var visitor_id = this.getCookie(this.visitor_id_cookie);
			if (!visitor_id) {
				visitor_id = this.createUUID();
			}
			this.setCookie(this.visitor_id_cookie, visitor_id, this.getVisitorExpiry());
			return visitor_id;
		};

		this.getVisitId = function () {
			var visit_id = this.getCookie(this.visit_id_cookie);
			if (!visit_id) {
				visit_id = this.createUUID();
			}
			this.setCookie(this.visit_id_cookie, visit_id, this.getVisitExpiry());
			return visit_id;
		};

		this.clearVisitId = function () {
			this.setCookie(this.visit_id_cookie, "", 'Thu, 01 Jan 1970 00:00:01 GMT');
		};

		this.getVisitorExpiry = function () {
			var d = new Date();
			// 1 year
			d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
			return d.toGMTString();
		};

		this.getVisitExpiry = function () {
			var d = new Date();
			// 4 hours
			d.setTime(d.getTime() + (4 * 60 * 60 * 1000));
			return d.toGMTString();
		};

		this.randomHexBlocks = function (blocks) {
			if (!blocks) {
				blocks = 4;
			}
			var hex = '';
			for (var i = 0; i < blocks; i++) {
				hex += parseInt(Math.random() * (Math.pow(2, 32))).toString(16);
			}
			return hex;
		};

		this.createUUID = function () {
			var s = [];
			var hexDigits = "0123456789abcdef";
			for (var i = 0; i < 36; i++) {
				s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
			}
			s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
			s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
			s[8] = s[13] = s[18] = s[23] = "-";

			var uuid = s.join("");
			return uuid;
		}


		// cookies borrowed from quirksmode
		this.setCookie = function (name, value, expiry) {
			var expires;
			if (expiry) {
				expires = "; expires=" + expiry;
			} else {
				expires = "";
			}
			document.cookie = name + "=" + value + expires + "; path=/";
		};

		this.getCookie = function (name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		};

		this.initialize(args);
	};

	// browser detection lifted from quirksmode
	HawkSearch.LilBro.BrowserDetect = {
		init: function () {
			this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
			this.version = this.searchVersion(navigator.userAgent)
				|| this.searchVersion(navigator.appVersion)
				|| "an unknown version";
			this.OS = this.searchString(this.dataOS) || "an unknown OS";
		},
		searchString: function (data) {
			for (var i = 0; i < data.length; i++) {
				var dataString = data[i].string;
				var dataProp = data[i].prop;
				this.versionSearchString = data[i].versionSearch || data[i].identity;
				if (dataString) {
					if (dataString.indexOf(data[i].subString) != -1)
						return data[i].identity;
				}
				else if (dataProp)
					return data[i].identity;
			}
		},
		searchVersion: function (dataString) {
			var index = dataString.indexOf(this.versionSearchString);
			if (index == -1) return;
			return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
		},
		dataBrowser: [
			{
				string: navigator.userAgent,
				subString: "BlackBerry",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "BB10",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "PlayBook",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "Chrome",
				identity: "Chrome"
			},
			{
				string: navigator.userAgent,
				subString: "OmniWeb",
				versionSearch: "OmniWeb/",
				identity: "OmniWeb"
			},
			{
				string: navigator.vendor,
				subString: "Apple",
				identity: "Safari",
				versionSearch: "Version"
			},
			{
				prop: window.opera,
				identity: "Opera",
				versionSearch: "Version"
			},
			{
				string: navigator.vendor,
				subString: "iCab",
				identity: "iCab"
			},
			{
				string: navigator.vendor,
				subString: "KDE",
				identity: "Konqueror"
			},
			{
				string: navigator.userAgent,
				subString: "Firefox",
				identity: "Firefox"
			},
			{
				string: navigator.vendor,
				subString: "Camino",
				identity: "Camino"
			},
			{// for newer Netscapes (6+)
				string: navigator.userAgent,
				subString: "Netscape",
				identity: "Netscape"
			},
			{
				string: navigator.userAgent,
				subString: "MSIE",
				identity: "Explorer",
				versionSearch: "MSIE"
			},
			{
				string: navigator.userAgent,
				subString: "Gecko",
				identity: "Mozilla",
				versionSearch: "rv"
			},
			{ // for older Netscapes (4-)
				string: navigator.userAgent,
				subString: "Mozilla",
				identity: "Netscape",
				versionSearch: "Mozilla"
			}
		],
		dataOS: [
			{
				string: navigator.userAgent,
				subString: "iPhone",
				identity: "iPhone/iPod"
			},
			{
				string: navigator.userAgent,
				subString: "iPod",
				identity: "iPhone/iPod"
			},
			{
				string: navigator.userAgent,
				subString: "iPad",
				identity: "iPad"
			},
			{
				string: navigator.userAgent,
				subString: "BlackBerry",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "BB10",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "PlayBook",
				identity: "BlackBerry"
			},
			{
				string: navigator.userAgent,
				subString: "Android",
				identity: "Android"
			},
			{
				string: navigator.platform,
				subString: "Win",
				identity: "Windows"
			},
			{
				string: navigator.platform,
				subString: "Mac",
				identity: "Mac"
			},
			{
				string: navigator.platform,
				subString: "Linux",
				identity: "Linux"
			}
		]
	};

	try {
		HawkSearch.LilBro.BrowserDetect.init();
	} catch (e) { }

	HawkSearch.Recommender = function (jQuery) {

		var self = this;
		this._uniqueId = null;
		var $ = jQuery;

		this.Init = function () {
			if (!HawkSearch.getRecommenderUrl()) {
				return;
			}

			log("Recommender init");

			if (HawkSearch.Context.containsKey("uniqueid")) {
				self._uniqueId = HawkSearch.Context["uniqueid"];
			}

			self._context = HawkSearch.RecommendationContext;
			self._context.enablePreview = HawkSearch.Recommender.IsPreviewEnabled();

			self._context.contextProperties = HawkSearch.Context;
			self._context.customProperties = HawkSearch.Context.Custom;
			$(".hawk-recommendation").each(function () {
				var uid = HawkSearch.Recommender.GetWidgetUid($(this).data("widgetguid"), $(this).data("uniqueid"));
				if ($(this).data("uniqueid") === undefined || uid.uniqueId === "") {
					uid.uniqueId = self._uniqueId;
				}
				var widgetExists = false;
				$(self._context.widgetUids).each(function () {
					var currentWidgetGuid = this.widgetGuid;
					if (currentWidgetGuid == uid.widgetGuid) {
						widgetExists = true;
						return;
					}
				})
				if (!widgetExists) {
					self._context.widgetUids.push(uid);
				}
			});

			if (self._context.widgetUids.length == 0) {
				return;
			}
			var recommenderUrl = HawkSearch.getRecommenderUrl() + "/api/recommendation/";

			var previewVisitorTargets = HawkSearch.Recommender.PreviewVisitorTarget();

			if (HawkSearch.Recommender.IsPreviewEnabled() && previewVisitorTargets != null && previewVisitorTargets !== "") {
				recommenderUrl = recommenderUrl + "?hawkb=" + previewVisitorTargets;
			}

			$.ajax({
				type: 'POST',
				url: recommenderUrl,
				data: JSON.stringify(self._context),
				contentType: "application/json",
				dataType: 'json'
			})
				.done(self.RegWidgets);
		}

		this.bindRecommendationPopover = function (container, ruleExplainDictionary, triggerRuleExplainDictionary) {
			container.find(".hawk-recommendation-item").each(function () {
				var modelType = $(this).data("hawk-modeltype");
				var modelName = $(this).data("hawk-modelname");
				var modelGuid = $(this).data("hawk-modelguid");
				var recInfoContainer = $(this).find(".hawk-recommendation-info");
				if (recInfoContainer.length === 0) {
					recInfoContainer = $("<div class='hawk-recommendation-info' data-trigger='hover'></div>");
					recInfoContainer.append($("<div class='hawk-recommendation-model-icon hawk-" + modelType.toLowerCase() + "'></div>"));
					$(this).prepend(recInfoContainer);
				}

				var ruleString = ruleExplainDictionary[modelGuid];
				var triggerRuleString = triggerRuleExplainDictionary[modelGuid];

				$(recInfoContainer).popover({
					html: true,
					placement: HawkSearch.getTipPlacementFunction('top', 230, 200),

					content: function () {
						var content = "<b>Strategy Name:</b> " + modelName;
						if (ruleString !== undefined && ruleString !== "") {
							content += "<div class=''>"
							content += "<div class=''><b>Rule:</b></div>";
							content += ruleString;
							content += "</div>";
						}

						if (triggerRuleString !== undefined && triggerRuleString !== "") {
							content += "<div class=''>"
							content += "<div class=''><b>Trigger Rule:</b></div>";
							content += triggerRuleString;
							content += "</div>";
						}

						return content;
					},
					trigger: 'hover',
					container: 'body'
				});

			});
		}

		this.RegWidgets = function (data) {
			if (!data.isSuccess) {
				return;
			}

			$(data.items).each(function () {
				var item = this;
				var contaierSelector = '.hawk-recommendation[data-widgetguid="' + item.widgetGuid + '"]';
				var widgetContainer = $(contaierSelector);
				if (widgetContainer.length > 0) {
					widgetContainer.attr("data-hawk-requestid", data.requestId);
					var layoutClass = "hawk-recommendation-" + (item.isVertical ? "vertical" : "horizontal");
					widgetContainer.addClass(layoutClass);
					widgetContainer.append("<div class='hawk-recommendation-inner'></div>");
					var widgetContainerInner = widgetContainer.find(".hawk-recommendation-inner");
					widgetContainerInner.css('visibility', 'hidden');
					widgetContainerInner.html(item.html);
					var hawkRecommendationItems = widgetContainerInner.find(".hawk-recommendation-item");
					widgetContainerInner.waitForImages(function () {
						var itemContainer = widgetContainerInner.find(".hawk-recommendation-list")

						hawkRecommendationItems.matchHeights({ includeMargin: true });

						if (!itemContainer.children().length) {
							widgetContainer.hide();
						}

						var container = $("#hawkitemlist");

						HawkSearch.ExposeEvents("RecommenderAfterWidgetImagesLoaded", { widgetContainer: widgetContainer });


						if (item.isCarousel) {
							if (item.carouselData.showNextPrevButtons) {
								widgetContainerInner.addClass("has-arrows");
							}
							if (item.carouselData.showDots) {
								widgetContainerInner.addClass("has-dots vertical-dots");
							}

							var autoRotateSpeed = item.carouselData.autoRotate ? item.carouselData.autoRotateSpeed : 0;
							var showDots = item.carouselData.showDots;
							var slickOptions = {
								speed: item.carouselData.animationSpeed,
								autoplay: item.carouselData.autoRotate,
								autoplaySpeed: item.carouselData.autoRotateSpeed,
								vertical: item.isVertical,
								slidesToShow: item.carouselData.nofVisible,
								arrows: item.carouselData.showNextPrevButtons,
								nextArrow: '<button type="button" class="hawk-carousel-next"><span>Next</span></button>',
								prevArrow: '<button type="button" class="hawk-carousel-prev"><span>Prev</span></button>',
								slidesToScroll: item.carouselData.scrollNumber,
								infinite: item.carouselData.isCircular,
								dots: item.carouselData.showDots,
								//variableWidth: (!item.isVertical),
								slide: ".hawk-recommendation-item",
								pauseOnHover: true,
								pauseOnDotsHover: true,
								mobileFirst: true
							};
							if (item.carouselData.enableResponsive) {
								var responsiveConfig = null;
								try {
									responsiveConfig = JSON.parse(item.carouselData.responseiveConfig);

								} catch (e) {
									log("Responsive data is corupted. WidgetGuid: " + item.widgetGuid + " Error:" + e);
								}
								if (responsiveConfig != null) {
									slickOptions.responsive = responsiveConfig;
								}
							}

							itemContainer.slick(slickOptions);

							if (!item.isVertical) {
								var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(true);
								var itemCount = item.carouselData.nofVisible;
								//itemContainer.width(itemWidth * itemCount);
								//widgetContainer.css( "maxWidth", widgetContainerInner.width() + 52 + "px");
								//widgetContainer.height(widgetContainerInner.height() + "px");
							}
							else {
								var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(true);
								//itemContainer.width(itemWidth + "px");
							}

							$(window).on("debouncedresize", function () {
								itemContainer.slick('slickGoTo', itemContainer.slick('slickCurrentSlide'), true);
							});
						} else {
							if (!item.isVertical) {
								var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(true);
								var itemCount = itemContainer.find(".hawk-recommendation-item").length;
								itemContainer.width(itemWidth * itemCount);
								widgetContainer.height(widgetContainerInner.height() + "px");
							}
							else {
								widgetContainer.width(widgetContainerInner.width() + "px");
							}
						}
						widgetContainer.append("<div class='clearfix'></div>");
						widgetContainerInner.css('visibility', 'visible');

						var enablePreview = HawkSearch.Recommender.IsPreviewEnabled();

						if (enablePreview) {
							var ruleExplainDictionary = new HawkSearch.Dictionary();
							var triggerRuleExplainDictionary = new HawkSearch.Dictionary();
							var bindPreview = function (data) {

								for (i = 0; i < data.length; i++) {
									var item = data[i];
									ruleExplainDictionary[item.ModelGuid] = item.RuleString;
									triggerRuleExplainDictionary[item.ModelGuid] = item.TriggerRuleString;
								}
								bindRecommendationPopover(widgetContainerInner, ruleExplainDictionary, triggerRuleExplainDictionary);
							};

							$(window).on("debouncedresize", function () {
								$(".hawk-recommendation-info").each(function (index, item) {
									$(item).popover('destroy');
								});

								setTimeout(function () {
									bindRecommendationPopover(widgetContainerInner, ruleExplainDictionary, triggerRuleExplainDictionary);
								}, 10);

							});
							var uriParser = document.createElement("a");
							var url = uriParser.href = HawkSearch.HawkUrl || HawkSearch.BaseUrl;
							var apiUrl = uriParser.protocol + "//" + uriParser.hostname + "/api/v3/RecommendationModel/getruleexplain?widgetGuid=" + item.widgetGuid + "&bu=" + encodeURIComponent(HawkSearch.getHawkUrl()) + "&cg=" + HawkSearch.getClientGuid();
							$.ajax({
								url: apiUrl,
								dataType: "jsonp",
								success: bindPreview
							});
						}
					});
				}
			});
			HawkSearch.ExposeEvents('RecommenderAfterInit');
		}
		this.Init();
	}
	HawkSearch.Recommender.PreviewInfoCookieName = "EnableRecommendationPreviewInfo";
	HawkSearch.Recommender.HawkPreviewBucket = "hawkPreviewBucket";

	HawkSearch.Recommender.GetWidgetUid = function (widgetGuid, uniqueId) {
		var uid = new Object();
		uid.widgetGuid = widgetGuid;
		uid.uniqueId = uniqueId;

		if (uniqueId !== undefined && uniqueId.match(/{{.+}}/)) {
			uid.uniqueId = "";
		}

		return uid;
	}

	HawkSearch.Recommender.SetWidget = function (widgetGuid, uniqueId) {
		HawkSearch.RecommendationContext.widgetUids.push(HawkSearch.Recommender.GetWidgetUid(widgetGuid, uniqueId));
	}

	HawkSearch.Recommender.IsPreviewEnabled = function () {
		var enablePreview = HawkSearch.lilBro.event.getCookie(HawkSearch.Recommender.PreviewInfoCookieName)

		return (enablePreview !== null && enablePreview.toLowerCase() === 'true');
	}

	HawkSearch.Recommender.ToggleRecPreview = function () {
		HawkSearch.Tracking.ready(function () {
			var toggleVal = HawkSearch.getHashOrQueryVariable("hawkToggleRecPreview");
			if (toggleVal !== "") {
				HawkSearch.lilBro.event.setCookie(HawkSearch.Recommender.PreviewInfoCookieName, toggleVal, HawkSearch.lilBro.event.getVisitorExpiry());
				var hawkb = HawkSearch.getHashOrQueryVariable("hawksetb");
				HawkSearch.lilBro.event.setCookie(HawkSearch.Recommender.HawkPreviewBucket, hawkb, HawkSearch.lilBro.event.getVisitorExpiry());
			}
		});
	}

	HawkSearch.Recommender.PreviewVisitorTarget = function () {
		return HawkSearch.lilBro.event.getCookie(HawkSearch.Recommender.HawkPreviewBucket);
	}

	HawkSearch.Recommender.Track = function (el, uniqueId, itemIndex) {
		var widgetGuid = HawkSearch.jQuery(el).parents(".hawk-recommendation").data("widgetguid");
		var recommendation = HawkSearch.jQuery(el).parents(".hawk-recommendation");
		var requestId = recommendation.data("hawk-requestid");
		HawkSearch.Tracking.writeRecommendationClick(widgetGuid, uniqueId, itemIndex, requestId);
	}

	function log(msg) {
		if (HawkSearchLoader.debugMode && window.console && console.log) {
			console.log('HawkSearch: ' + msg);
		};
	}

	if (HawkSearchLoader.loadjQuery) {
		log('Loading jQuery/jQuery UI.');
		// set document head to varible
		var head = (document.getElementsByTagName("head")[0] || document.documentElement),
			script = "//manage.hawksearch.com/sites/shared/includes/jquery-1.11.0_jquery-ui-slider-1.10.4.min.js";

		var jqScriptTag = document.createElement('script');
		jqScriptTag.type = 'text/javascript';
		jqScriptTag.src = script;

		// Handle Script loading
		// IE9+ supports both script.onload AND script.onreadystatechange (bit.ly/18gsqtw)
		// so both events will be triggered (that's 2 calls), which is why "jqLoadDone" is needed
		var jqLoadDone = false;

		// Attach handlers for all browsers
		jqScriptTag.onload = jqScriptTag.onreadystatechange = function () {
			if (!jqLoadDone && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
				jqLoadDone = true;

				log("jQuery applied and ready");
				jQueryLoaded();

				// Handle memory leak in IE
				jqScriptTag.onload = jqScriptTag.onreadystatechange = null;
				if (head && jqScriptTag.parentNode) {
					head.removeChild(jqScriptTag);
				}
			}
		};


		// add script to page's head tag.
		// Use insertBefore instead of appendChild  to circumvent an IE6 bug.
		// This arises when a base node is used (#2709 and #4378).
		head.insertBefore(jqScriptTag, head.firstChild);

	} else {
		jQuery = window.jQuery;
		containedHawkSearchInitializer(jQuery);
	}

	function jQueryLoaded() {
		log('Finalizing JS Component Binding');
		jQuery = window.jQuery.noConflict(true);

		log('Local jQuery version: ' + jQuery.fn.jquery);

		if (window.jQuery)
			log('Global jQuery version: ' + window.jQuery.fn.jquery);
		else {
			log('No Global jQuery present. Adding current jQuery');
			window.jQuery = jQuery;
		}
		containedHawkSearchInitializer(jQuery);
	};

	//Since we're loading jQuery dynamically and are using callbacks, we need to store all of our
	//plugins inside a single function that passes $ aliased from our version of jQuery.
	function containedHawkSearchInitializer($) {
		// BEGIN Namespaced HawkSearch block.

		(function (HawkSearch, $) {
			HawkSearch.loadingtpl = '<img src="//manage.hawksearch.com/sites/shared/images/global/load.gif" style="margin:0 5px;vertical-align:middle;" />';
			HawkSearch.loadtimer = null;
			HawkSearch.scroll = false;
			HawkSearch.processing = false;

			HawkSearch.disableAjax = function () {
				return false;
			};

			HawkSearch.getHash = function () {
				var hashSplit = window.location.toString().split("#");
				if (hashSplit.length > 1) return hashSplit[1];
				return window.location.search.substring(1);
			};

			HawkSearch.lilBro = new HawkSearch.LilBro({
				server: HawkSearch.getHawkUrl(),
				server_ssl: HawkSearch.getHawkUrl() + ':443',
				watch_focus: false,
				watch_click: false,
				event_base: HawkSearch.EventBase,
				qs: encodeURIComponent(HawkSearch.getHash()),
				jQuery: $
			});

			HawkSearch.jQuery = $;

			/* Not necessary?
			HawkSearch.normalizeHeights = function () {
				var container = $("#hawkitemlist");
				var topcontainer = $("#hawkbannertop");
				var targetElement = container.find(".itemWrapper");
			};
			*/

			HawkSearch.regTracking = function () {
				log("Register Tracking");

				$(".hawk-bannerLink,.hawk-banner").each(function () {
					var bannerId = $(this).data("bannerid");
					HawkSearch.Tracking.writeBannerImpression(bannerId);
				});

				// BEGIN BLAIN CUSTOM: Tracking link click
				$(".product-hawklink").off("click.hawktrack").on("click.hawktrack", function (e) {
					var index = $(this).data('index');
					var sku = $(this).attr('data-blain');
					return HawkSearch.TrackingActions.productCatalogClick(e, index, sku);
				});
				// END BLAIN CUSTOM: Tracking link click
			};

			HawkSearch.TrackingActions = {
				productCatalogClick (e, index, sku) {
					if (!sku) return;
					var trackingId = HawkSearch.lilBro.getTrackingId();
					return HawkSearch.link(e, trackingId, index, sku,0);
				},
			}

			HawkSearch.refreshUrl = function (event, forceReload) {
				$("#hdnhawkcompare").val(window['hawktocompare'].join(","));

				var qs = "";
				var prevName = "";
				var vals = "";
				var keyword = $("#hdnhawkkeyword").val();
				var prv = $("#hdnhawkprv").val();
				var lp = $("#hdnhawklp").val();
				var adv = $("#hdnhawkadv").val();
				var searchWithin = $("#searchWithin").val();
				var pg = $("#hdnhawkpg").val();
				var mpp = $("#hdnhawkmpp").val();
				var sort = $("#hdnhawksortby").val();
				var it = $("#hdnhawkit").val();
				var items = $("#hdnhawkcompare").val();
				var operator = $("#hdnhawkoperator").val();
				var expand = $("#hdnhawkexpand").val();
				var hawkb = $("#hdnhawkb").val();
				var defaultmpp = $("#hdnhawkdefaultmpp").val();
				var keywordfield = $("#hdnhawkkeywordfield").val();
				var previewDate = typeof smartbugDatetimepicker != 'undefined' ? smartbugDatetimepicker.hawkDate : null;
				var hawkflags = $('#hdnhawkflags').val();
				var aid = $("#hdnhawkaid").val();
				var hawkp = $("#hdnhawkp").val();

				if (keyword && keyword !== "") qs += (qs === "" ? "" : "&") + keywordfield + "=" + encodeURIComponent(keyword);
				if (prv && prv !== "") qs += (qs === "" ? "" : "&") + "prv=" + encodeURIComponent(prv);
				if (lp && lp !== "") qs += (qs === "" ? "" : "&") + "lp=" + encodeURIComponent(lp);
				if (adv && adv !== "") qs += (qs === "" ? "" : "&") + "adv=" + encodeURIComponent(adv);
				if (searchWithin && searchWithin !== "") qs += (qs === "" ? "" : "&") + "searchWithin=" + encodeURIComponent(searchWithin);
				if (sort && sort !== "") qs += (qs === "" ? "" : "&") + "sort=" + encodeURIComponent(sort);
				if (it && it !== "") qs += (qs === "" ? "" : "&") + "it=" + encodeURIComponent(it);
				if (items && items !== "") qs += (qs === "" ? "" : "&") + "items=" + encodeURIComponent(items);
				if (operator && operator !== "") qs += (qs === "" ? "" : "&") + "operator=" + encodeURIComponent(operator);
				if (expand && expand !== "") qs += (qs === "" ? "" : "&") + "expand=" + encodeURIComponent(expand);
				if (hawkb && hawkb !== "") qs += (qs === "" ? "" : "&") + "hawkb=" + encodeURIComponent(hawkb);
				if (previewDate) qs += (qs === "" ? "" : "&") + "HawkDate=" + previewDate;
				if (hawkflags && hawkflags !== "") qs += (qs === "" ? "" : "&") + "hawkflags=" + encodeURIComponent(hawkflags);
				if (aid && aid !== "") qs += (qs === "" ? "" : "&") + "hawkaid=" + encodeURIComponent(aid);
				if (hawkp && hawkp !== "") qs += (qs === "" ? "" : "&") + "hawkp=" + encodeURIComponent(hawkp);

				$(".hawk-facetFilters li.hawkFacet-active > a").each(function () {
					var options = $(this).data().options;
					if (options.name !== prevName) {
						if (vals !== "") qs += (qs === "" ? "" : "&") + encodeURIComponent(prevName) + '=' + vals;
						vals = "";
					}
					vals += (vals === "" ? "" : ",") + encodeURIComponent(options.value.replace(/,/g, "%c%"));
					prevName = options.name;
				});

				if (prevName !== "" && vals !== "") qs += (qs === "" ? "" : "&") + encodeURIComponent(prevName) + '=' + vals;

				if ($("input.hawk-numericInput").length) {

					var minInput = $("input.hawk-numericInput.numeric-from");
					var maxInput = $("input.hawk-numericInput.numeric-to");

					minInput.numeric();
					maxInput.numeric();


					minInput.blur(function () {
						var val = parseFloat(minInput.val().replace(/[^0-9\.]+/g, ""));

						var type = minInput.data("type");
						if (type == 'currency') {
							minInput.val(HawkSearch.formatCurrency(val));
						}
					});
					maxInput.blur(function () {
						var val = parseFloat(maxInput.val().replace(/[^0-9\.]+/g, ""));

						var type = maxInput.data("type");
						if (type == 'currency') {
							maxInput.val(HawkSearch.formatCurrency(val));
						}
					});

					minInput.on("focus", function () {
						minInput.attr("data-orgval", minInput.val().replace(/[^0-9\.]+/g, ""));
					});
					maxInput.on("focus", function () {
						maxInput.attr("data-orgval", maxInput.val().replace(/[^0-9\.]+/g, ""));
					});

					var minValue = parseFloat(minInput.data("min"));
					var maxValue = parseFloat(maxInput.data("max"));
					var isInvalid = false;

					var numericFrom = $(minInput.parent().find(".numeric-from"));
					var numericTo = $(minInput.parent().find(".numeric-to"));

					var fromVal = parseFloat(minInput.val().replace(/[^0-9\.]+/g, ""));
					var toVal = parseFloat(maxInput.val().replace(/[^0-9\.]+/g, ""));

					var orgMinVal = parseFloat(minInput.data("orgval"));
					var orgMaxVal = parseFloat(maxInput.data("orgval"));

					if (numericFrom < minValue || numericTo > maxValue || fromVal > toVal) {
						isInvalid = true;
						fromVal = minValue;
						toVal = maxValue;
					}

					var minType = minInput.data("type");
					if (minType == 'currency') {
						minInput.val(HawkSearch.formatCurrency(fromVal));
					} else {
						minInput.val(fromVal);
					}

					var maxType = maxInput.data("type");
					if (maxType == 'currency') {
						maxInput.val(HawkSearch.formatCurrency(toVal));
					} else {
						maxInput.val(toVal);
					}

					if (isInvalid) {
						return;
					}
					var name = minInput.parent().parent().find(".hawk-sliderRangeInput").attr("name");
					if (parseFloat(minValue) !== parseFloat(fromVal) || parseFloat(maxValue) !== parseFloat(toVal)) {
						qs += (qs === "" ? "" : "&") + encodeURIComponent(name) + '=' + encodeURIComponent(fromVal) + ',' + encodeURIComponent(toVal);
					}
				}

				//todo change this
				if (mpp && mpp !== "" && mpp !== "60") qs += (qs === "" ? "" : "&") + "mpp=" + encodeURIComponent(mpp);
				if (pg && pg !== "" && pg !== "1") qs += (qs === "" ? "" : "&") + "pg=" + encodeURIComponent(pg);

				// cancel refresh if hash is not changed
				if (window.location.hash === "#" + qs) {
					return;
				}

				if (HawkSearch.disableAjax() || forceReload) {
					var url = window.location.toString();
					if (url.indexOf("?") > -1) url = url.substring(0, url.indexOf("?"));
					if (url.indexOf("#") > -1) url = url.substring(0, url.indexOf("#"));
					window.location = url + '?' + qs;
				} else {
					if (window.location.hash !== "" || qs !== "") {
						var scroll = $(document).scrollTop();
						window.history.pushState({}, {}, "?" + qs);
						if (qs === "") {
							$(document).scrollTop(scroll);
						}
					}
					else if (qs === "") {
						window.history.pushState({}, {}, window.location.pathname);
					}

				}

			};

			HawkSearch.resetSearch = function () {
				$("#hdnhawkpg").val(1);
				if (window.location.hash !== "") {
					window.location.hash += "&";
				}
				HawkSearch.clearAllFacets();
			}

			HawkSearch.getCustomUrl = function () {
				var lpurl = window.location.pathname;
				if (lpurl.indexOf('/preview.aspx') >= 0) {
					lpurl = '';
				}
				if (lpurl.indexOf('/search/') >= 0) {
					lpurl = '';
				}
				return lpurl;
			};
			HawkSearch.IsExplainPopupOpen = false;

			HawkSearch.getPinFunctionUrl = function (f, itemId) {
				var keywordField = $('#hdnhawkkeywordfield').val();
				var keyword = HawkSearch.getHashOrQueryVariable(keywordField);
				var lpurl = HawkSearch.getCustomUrl();
				var lpId = $("#hdnhawklp").val();
				return HawkSearch.BaseUrl + "/?fn=ajax&f=" + f + "&itemId=" + encodeURIComponent(itemId) + "&" + keywordField + "=" + keyword + "&lp=" + encodeURIComponent(lpId) + "&lpurl=" + encodeURIComponent(lpurl) + "&hawkb=" + HawkSearch.getHashOrQueryVariable("hawkb") + "&hawkaid=" + HawkSearch.getHashOrQueryVariable("hawkaid") + "&hawkp=" + HawkSearch.getHashOrQueryVariable("hawkp");
			}

			HawkSearch.addToTop = function (el, itemId) {

				var url = HawkSearch.getPinFunctionUrl("AddItemToTop", itemId);
				var currentEl = el;
				$.ajax({
					type: "GET",
					async: true,
					context: el,
					contentType: "application/json; charset=utf-8",
					url: url,
					dataType: "jsonp",
					success: function () {
						log("Added item to top");
						var parentContainer = $(this).parents(".grid_3");
						parentContainer.addClass("hawk-itemPinned");
						parentContainer.find(".preview-info").append("<span class='hawkIcon-itemPinned'></span>");
						$(".itemWrapper.hawk-itemWrapper").removeClass("hawk-itemPinned preview-info");

						$(this).parents(".popover").popover('hide');
					},
					error: function (e) {
						log("ERROR: Add item to top " + e);
					}
				});
			}

			HawkSearch.unpinItem = function (el, itemId) {
				var keywordField = $('#hdnhawkkeywordfield').val();
				var keyword = HawkSearch.getHashOrQueryVariable(keywordField);
				var lpurl = HawkSearch.getCustomUrl();
				var lpId = $("#hdnhawklp").val();
				var url = HawkSearch.getPinFunctionUrl("UnpinItem", itemId);

				$.ajax({
					type: "GET",
					async: true,
					contentType: "application/json; charset=utf-8",
					url: url,
					context: el,
					dataType: "jsonp",
					success: function () {
						log("Unpin item");
						var parentContainer = $(this).parents(".grid_3");
						parentContainer.removeClass("hawk-itemPinned");
						parentContainer.find(".hawkIcon-itemPinned").remove();
						$(this).parents(".popover").popover('hide');
					},
					error: function (e) {
						log("ERROR: Unpin item " + e);
					}
				});
			};

			HawkSearch.updatePinOrder = function (itemOrder) {
				var url = HawkSearch.getPinFunctionUrl("UpdateItemPinOrder", 0);
				url += "&itemList=" + encodeURIComponent(itemOrder);

				$.ajax({
					type: "GET",
					async: true,
					contentType: "application/json; charset=utf-8",
					url: url,
					dataType: "jsonp",
					success: function () {
						log("UpdateItemPinOrder");
					},
					error: function (e) {
						log("ERROR: UpdateItemPinOrder " + e);
					}
				});
			}

			HawkSearch.explain = function (docid) {
				if (HawkSearch.IsExplainPopupOpen) {
					return;
				}

				HawkSearch.IsExplainPopupOpen = true;

				var keyword = $("#hdnhawkkeyword").val();
				var keywordField = $("#hdnhawkkeywordfield").val();
				var keywordfromQuery = HawkSearch.getHashOrQueryVariable(keywordField);
				var hash = window.location.search.substring(1);
				if (keyword.toLowerCase() != decodeURIComponent(keywordfromQuery.toLowerCase().replace(/\+/g, " "))) {
					hash = hash.replace(keywordField + '=' + keywordfromQuery, keywordField + '=' + encodeURIComponent(keyword));
				}
				if (hash === "" || (window.location.search.substring(1) !== "" && window.location.href.indexOf("#") > -1)) hash = HawkSearch.getHash();

				var lpurl = HawkSearch.getCustomUrl();
				var hawkcustom = $("#hdnhawkcustom").val();
				var full = HawkSearch.BaseUrl + "/?" + hash + "&ajax=1&json=1&docid=" + encodeURIComponent(docid) + (lpurl != '' ? "&lpurl=" + encodeURIComponent(lpurl) : "") + (hawkcustom != '' ? "&hawkcustom=" + encodeURIComponent(hawkcustom) : "");
				full += "&hawkvisitorid=" + HawkSearch.lilBro.event.getVisitorId()

				$.ajax({ "type": "GET", "data": "", "async": "false", "contentType": "application/json; charset=utf-8", "url": full, "dataType": "jsonp", "success": HawkSearch.showAjaxPopup });
			};

			HawkSearch.loadMoreLikeThis = function (event, arg) {
				var argsArr = arg.split('|');
				var pk = argsArr[0];
				var trackingId = HawkSearch.lilBro.getTrackingId();
				if (argsArr.length >= 3) {
					trackingId = argsArr[2];
				}
				HawkSearch.Tracking.writeClick(event, 0, true, pk, trackingId);

				var url = HawkSearch.BaseUrl + "/default.aspx?fn=ajax&f=MoreLikeThis&args=" + arg;

				$.ajax({
					"type": "GET",
					"data": "",
					"async": "false",
					"contentType": "application/json; charset=utf-8",
					"url": url,
					"dataType": "jsonp",
					"success": function (data) {
						HawkSearch.bootbox.dialog({
							title: "More Like This",
							message: data.Html,
							buttons: {
								main: {
									label: "Close"
								}
							}
						});
					}
				});
			};

			HawkSearch.HawkSubmit = (function (e) {
				var field = $(e).find('input[name=' + $('#hdnhawkkeywordfield').val() + ']');
				var keywords = $(field).val();
				var id = $(field).attr('id')
				if (!(field.length == 0 && $('#hdnhawkkeyword').length == 0)) {
					if ((keywords == HawkSearch.SuggesterGlobal.defaultKeyword[id]) || (keywords == $('#hdnhawkkeyword').val())) {
						return false;
					}
				}
				return true;
			});

			HawkSearch.showAjaxPopup = function (json) {
				var html = json.html;
				var objs = $(html);

				var obj = objs.find("#hawkexplain");
				if (obj != null && obj.length > 0) $("#divAjaxPopupContent").html(obj.html());
				HawkSearch.bootbox.dialog({
					title: "Item details",
					message: obj.html(),
					buttons: {
						main: {
							label: "Close"
						}
					}
				});

				HawkSearch.IsExplainPopupOpen = false;
			};

			HawkSearch.hideBlockUI = function () {
				if (HawkSearch.processing || HawkSearch.scroll) {
					return;
				}
				$.unblockUI({ "fadeOut": 0 });
			};

			HawkSearch.showBlockUI = function () {
				$.blockUI({ "message": HawkSearch.loadingtpl, "fadeIn": 0, overlayCSS: { backgroundColor: '#fff', opacity: 0.5, cursor: 'wait' }, "css": { "borderWidth": "0px", top: ($(window).height() - 100) / 2 + 'px', left: ($(window).width()) / 2 + 'px', width: '0px' } });
			};

			HawkSearch.getUrl = function () {
				var url = window.location.toString();
				if (url.indexOf("?") > -1) url = url.substring(0, url.indexOf("?"));
				if (url.indexOf("#") > -1) url = url.substring(0, url.indexOf("#"));

				return url;
			};


			HawkSearch.copyValue = function (objs, name) {
				var obj = objs.find(name);
				if (obj != null && obj.length > 0) $(name).html(obj.html());
			};

			HawkSearch.copyCustomBanners = function (objs) {

				$(objs).find(".hawk-bannerZone").each(function () {
					var name = "#" + $(this).attr("id");
					var obj = objs.find(name);
					if (obj != null && obj.length > 0 && obj.html().trim() != "") {
						if ($("#hdnhawkprv").val() == "1") {
							$(obj).prepend('<span class="hawk-customBannerTitle">' + obj.attr("title") + '</span>')
						}
						$(name).html(obj.html());
					}
					else {
						$(name).html("");
					}
				})
			};

			HawkSearch.clearAllFacets = function () {
				var keyword = $("#hdnhawkkeyword").val();
				var prv = $("#hdnhawkprv").val();
				var lp = $("#hdnhawklp").val();
				var adv = $("#hdnhawkadv").val();
				var mpp = $("#hdnhawkmpp").val();
				var sort = $("#hdnhawksortby").val();
				var it = $("#hdnhawkit").val();
				var items = $("#hdnhawkcompare").val();
				var operator = $("#hdnhawkoperator").val();
				var expand = $("#hdnhawkexpand").val();
				var hawkb = $("#hdnhawkb").val();
				var defaultmpp = "60";
				var keywordfield = $("#hdnhawkkeywordfield").val();
				var hawkflags = $('#hdnhawkflags').val();
				var aid = $("#hdnhawkaid").val();
				var qs = '';

				if (keyword && keyword !== "") qs += (qs === "" ? "" : "&") + keywordfield + "=" + encodeURIComponent(keyword);
				if (prv && prv !== "") qs += (qs === "" ? "" : "&") + "prv=" + encodeURIComponent(prv);
				if (lp && lp !== "") qs += (qs === "" ? "" : "&") + "lp=" + encodeURIComponent(lp);
				if (adv && adv !== "") qs += (qs === "" ? "" : "&") + "adv=" + encodeURIComponent(adv);
				if (mpp && mpp !== "" && mpp !== defaultmpp) qs += (qs === "" ? "" : "&") + "mpp=" + encodeURIComponent(mpp);
				if (sort && sort !== "") qs += (qs === "" ? "" : "&") + "sort=" + encodeURIComponent(sort);
				if (it && it !== "") qs += (qs === "" ? "" : "&") + "it=" + encodeURIComponent(it);
				if (items && items !== "") qs += (qs === "" ? "" : "&") + "items=" + encodeURIComponent(items);
				if (operator && operator !== "") qs += (qs === "" ? "" : "&") + "operator=" + encodeURIComponent(operator);
				if (expand && expand !== "") qs += (qs === "" ? "" : "&") + "expand=" + encodeURIComponent(expand);
				if (hawkb && hawkb !== "") qs += (qs === "" ? "" : "&") + "hawkb=" + encodeURIComponent(hawkb);
				if (hawkflags && hawkflags !== "") qs += (qs === "" ? "" : "&") + "hawkflags=" + encodeURIComponent(hawkflags);
				if (aid && aid !== "") qs += (qs === "" ? "" : "&") + "hawkaid=" + encodeURIComponent(aid);

				if (HawkSearch.disableAjax()) {
					var url = window.location.toString();
					if (url.indexOf("?") > -1) url = url.substring(0, url.indexOf("?"));
					if (url.indexOf("#") > -1) url = url.substring(0, url.indexOf("#"));
					window.location = url + '?' + qs;
				} else {
					if (qs) {
						window.history.pushState({}, {}, "?" + qs);
					} else {
						window.history.pushState({}, {}, window.location.pathname);
					}

				}
			};

			HawkSearch.getHashOrQueryVariable = function (variable) {
				var query = HawkSearch.getHash();
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0].toLowerCase() == variable.toLowerCase()) {
						return pair[1];
					}
				}
				return HawkSearch.getQueryVariable(window.location.search.substring(1), variable);
			};

			HawkSearch.getQueryVariable = function (url, variable) {
				if (variable === undefined || variable === null) {
					return "";
				}

				var query = url;
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0].toLowerCase() == variable.toLowerCase()) {
						return pair[1];
					}
				}
				return "";
			};

			HawkSearch.getRecommenderUrl = function () {
				if (HawkSearch.RecommenderUrl === undefined || HawkSearch.RecommenderUrl === "") {
					return null;
				}
				else {
					return HawkSearch.RecommenderUrl;
				}
			}

			HawkSearch.link = function (event, id, i, pk, mlt) {
				if (event.currentTarget === undefined || event.currentTarget.href === undefined) {
					return true;
				}

				if (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2) {
					HawkSearch.Tracking.writeClick(event, i, mlt, pk, id);
				}
				else if (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2AndSql) {
					HawkSearch.Tracking.writeClick(event, i, mlt, pk, id);
					HawkSearch.Tracking.V1.link(event, id, i, pk, mlt);
				}
				else {
					HawkSearch.Tracking.V1.link(event, id, i, pk, mlt);
				}

				return true;
			};

			HawkSearch.bannerLink = function (el, id) {
				if (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2) {
					HawkSearch.Tracking.writeBannerClick(el, id);
				}
				else if (HawkSearch.Tracking.CurrentVersion() == HawkSearch.Tracking.Version.v2AndSql) {
					HawkSearch.Tracking.writeBannerClick(el, id);
					HawkSearch.Tracking.V1.bannerLink(el, id);
				}
				else {
					HawkSearch.Tracking.V1.bannerLink(el, id);
				}

				return true;
			};

			HawkSearch.formatCurrency = function (num) {
				num = num.toString().replace(/\$|\,/g, '');
				if (isNaN(num))
					num = "0";
				var sign = (num == (num = Math.abs(num)));
				num = Math.floor(num * 100 + 0.50000000001);
				var cents = num % 100;
				num = Math.floor(num / 100).toString();
				if (cents < 10)
					cents = "0" + cents;
				for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
					num = num.substring(0, num.length - (4 * i + 3)) + ',' +
						num.substring(num.length - (4 * i + 3));
				return (((sign) ? '' : '-') + '$' + num + '.' + cents);
			};

			HawkSearch.preserveUrlParams = function () {
				var prv = HawkSearch.GetQueryStringValue["prv"] + '';
				var adv = HawkSearch.GetQueryStringValue["adv"] + '';
				var hawkflags = HawkSearch.GetQueryStringValue["hawkflags"] + '';
				var aid = HawkSearch.GetQueryStringValue["hawkaid"] + '';
				var ret = '';

				if (prv != "undefined" && prv != '') ret += '&prv=' + escape(prv);
				if (adv != "undefined" && adv != '') ret += '&adv=' + escape(adv);
				if (hawkflags != "undefined" && hawkflags != '') ret += '&hawkflags=' + escape(hawkflags);
				if (aid != "undefined" && aid != '') ret += '&hawkaid=' + escape(aid);

				return ret;
			};


			//Recent Searches

			HawkSearch.clearRelatedSearches = function () {
				$.cookie("recent-searches", "", { expires: -1 });
				$(".hawk-recentSearches .hawk-navGroupContent > ul").empty();
				$(".hawk-recentSearches").hide();
			};

			HawkSearch.GetRecentSearches = function () {
				var recentSearchesStr = $.cookie("recent-searches");
				var recentSearches = [];
				if (recentSearchesStr != null) {
					var rsObjeArr = recentSearchesStr.split(",");
					$(rsObjeArr).each(function () {
						var obj = this.split("|");
						if (obj.length > 1) {
							var srch = {};
							srch.keyword = obj[0];
							srch.count = obj[1];
							recentSearches.push(srch);
						}
					});
				}

				var keyword = HawkSearch.RecentSearchesKeyword;
				var count = HawkSearch.RecentSearchesCount;
				if (keyword !== "" && count > 0) {
					var exists = false;
					for (var i = 0; i < recentSearches.length; i++) {
						if (recentSearches[i].keyword == encodeURIComponent(keyword)) {
							exists = true;
							break;
						}
					}
					if (!exists) {
						var search = new Object();
						search.keyword = encodeURIComponent(keyword);
						search.count = count;
						recentSearches.unshift(search);
					}
				}
				if (recentSearches.length == 0) {
					$(".hawk-recentSearches").hide();
				}
				var maxRecentSearchesCount = HawkSearch.RecentSearchesRecentSearchesCount;
				var numberOrSearches = Math.min(recentSearches.length, maxRecentSearchesCount);
				for (var j = 0; j < numberOrSearches; j++) {
					var k = recentSearches[j].keyword;
					var c = recentSearches[j].count;
					$(".hawk-recentSearches .hawk-navGroupContent > ul").append("<li><a href='" + HawkSearch.RecentSearchesUrl + "?" + $("#hdnhawkkeywordfield").val() + "=" + k + "' rel='nofolow'>" + decodeURIComponent(k) + "<span class='count'> (" + c + ")</span></a></li>");
				}

				$(".hawk-recentSearches .hawk-navGroupContent > ul li a").click(function () {
					window.location = $(this).attr("href");
				});
				var tempArray = [];
				$(recentSearches).each(function () {
					tempArray.push(this.keyword + "|" + this.count);
				});
				recentSearchesStr = tempArray.join(",");
				$.cookie("recent-searches", recentSearchesStr, { expires: 365 });
			};

			HawkSearch.getTipPlacementFunction = function (defaultPosition, width, height) {
				return function (tip, element) {
					var position, top, bottom, left, right;

					var $element = $(element);
					var boundTop = $(document).scrollTop();
					var boundLeft = $(document).scrollLeft();
					var boundRight = boundLeft + $(window).width();
					var boundBottom = boundTop + $(window).height();

					var pos = $.extend({}, $element.offset(), {
						width: element.offsetWidth,
						height: element.offsetHeight
					});

					var isWithinBounds = function (elPos) {
						return boundTop < elPos.top && boundLeft < elPos.left && boundRight > (elPos.left + width) && boundBottom > (elPos.top + height);
					};

					var testTop = function () {
						if (top === false) return false;
						top = isWithinBounds({
							top: pos.top - height,
							left: pos.left + pos.width / 2 - width / 2
						});
						return top ? "top" : false;
					};

					var testBottom = function () {
						if (bottom === false) return false;
						bottom = isWithinBounds({
							top: pos.top + pos.height,
							left: pos.left + pos.width / 2 - width / 2
						});
						return bottom ? "bottom" : false;
					};

					var testLeft = function () {
						if (left === false) return false;
						left = isWithinBounds({
							top: pos.top + pos.height / 2 - height / 2,
							left: pos.left - width
						});
						return left ? "left" : false;
					};

					var testRight = function () {
						if (right === false) return false;
						right = isWithinBounds({
							top: pos.top + pos.height / 2 - height / 2,
							left: pos.left + pos.width
						});
						return right ? "right" : false;
					};

					switch (defaultPosition) {
						case "top":
							if (position = testTop()) return position;
						case "bottom":
							if (position = testBottom()) return position;
						case "left":
							if (position = testLeft()) return position;
						case "right":
							if (position = testRight()) return position;
						default:
							if (position = testTop()) return position;
							if (position = testBottom()) return position;
							if (position = testLeft()) return position;
							if (position = testRight()) return position;
							return defaultPosition;
					}
				}
			};

			HawkSearch.PopoverShow = function ($this) {
				$this.addClass("bounded");
				var tip = $this.popover();
				var popover = $(tip).data("bs.popover");
				if ($this.data("tipclass") !== undefined) {
					popover.tip().addClass($this.data("tipclass"));
				}
				tip.on("shown.bs.popover", function (e) {
					$this.mouseleave(function () {
						setTimeout(function () {
							HawkSearch.TipMouseLeave($this);
						}, 250);
					});

					popover.tip().hover(function () {
						$(this).addClass("hover");
					},
					function () {
						$(this).removeClass("hover");
					});

					popover.tip().mouseleave(function () {
						setTimeout(function () {
							HawkSearch.TipMouseLeave($this);
						}, 250);
					});
				});

				$this.data("popover");
				$this.popover('show');
			}

			HawkSearch.TipMouseLeave = function (that) {
				var tip = that.data("bs.popover").tip();
				if (tip.hasClass("hover")) {
					return;
				} else {
					tip.hide();
					that.removeClass("hover");
				}
			}

			HawkSearch.BindFacetTooltip = function () {
				$(".hawk-facet-tooltip").each(function () {
					$(this).click(function (e) {
						e.preventDefault();
						e.stopPropagation();
					});
					var content = $(this).parent().find(".hawk-facet-tooltip-content").html();
					$(this).popover({
						html: true,
						placement: 'right',
						content: content,
						container: 'body'
					});
					$(this).mouseover(function () {
						$(this).addClass("hover");
						var $this = $(this);
						if ($this.hasClass("bounded")) {
							var popup = $(this).parent().find(".popover");
							if (!popup.is(":visible")) {
								$this.popover("show");
							}
							return;
						}
						HawkSearch.PopoverShow($(this));
					});
				});
			}

			HawkSearch.BindBackToTop = function () {
				$(window).scroll(function () {
					var divBackToTop = $("#hawk-backToTop");
					if ($(window).scrollTop() > 0) {
						if (!divBackToTop.is(":visible")) {
							divBackToTop.fadeIn({ duration: 200, queue: false });
						}
					}
					else {
						if (divBackToTop.is(":visible")) {
							divBackToTop.fadeOut({ duration: 200, queue: false });
						}
					}
				});
				$("#hawk-backToTop").hover(function () {
					$(this).toggleClass("hover");
				});
				$("#hawk-backToTop").on("click", function () {
					$('html,body').animate({ scrollTop: 0 }, 500);
				});
			}

			HawkSearch.SetFacetScrollPosition = function () {
				var menuYloc = $(".hawk-facetScollingContainer").offset().top - $(".hawk-facetScollingContainer").position().top;
				var footerHeight = $(".footer").outerHeight();
				var footerOffsetTop = $(".footer").offset().top;


				var menuHeight = $(".hawk-facetScollingContainer").outerHeight();
				var winHeight = $(window).height();
				var offset = 0;
				var docScroll = $(document).scrollTop();
				var diff = menuHeight - winHeight;
				if (winHeight < menuHeight) {
					offset = docScroll - diff - menuYloc;
					if (docScroll < diff) {
						offset = 0;
					}

				} else {
					offset = docScroll - menuYloc + 10;
				}

				if (offset < 0) {
					offset = 0;
				}

				if (offset + menuHeight + menuYloc >= footerOffsetTop) {
					offset = footerOffsetTop - menuHeight - menuYloc - 20;
				}

				$(".hawk-facetScollingContainer").animate({ top: offset }, { duration: 500, queue: false });
			}

			HawkSearch.FacetContainerScrollable = function () {
				$(window).scroll(function () {
					HawkSearch.SetFacetScrollPosition();

				});

			}

			// exposes custom jQuery events to the body
			HawkSearch.ExposeEvents = function (type, args) {
				var callback = $.Event('hawk' + type, args);
				$('body').trigger(callback);

				// if prevent default block execution
				return !callback.isDefaultPrevented();
			}

			HawkSearch.Tracking.setReady($);

			if (HawkSearch.getHashOrQueryVariable("hawkRegVisitor") !== "") {
				parent.postMessage(HawkSearch.lilBro.event.getVisitorId(), "*");
			}

			HawkSearch.Recommender.ToggleRecPreview();
		}(window.HawkSearch = window.HawkSearch || {}, jQuery));

		(function (HawkCompare, $) {
			HawkCompare.process = function () {
				var itemIds = $("#hdnhawkcompare").val();
				if (itemIds === "") return;
				//alert('Compare feature is not available on denniskirk site');
				var itemIds = $("#hdnhawkcompare").val();
				if (itemIds === "") return;

				var url = HawkSearch.BaseUrl + "?fn=compare&Items=" + itemIds;
				$.get(url, function (data) {
					var html = data;
					HawkSearch.bootbox.dialog({
						title: 'Compare Items',
						message: html,
						className: 'hawk-compare hawk-preview',
						buttons: {
							main: {
								label: "Close"
							}
						}
					});
					$(".item.span3 .product-shop .product-name").matchHeights();
				});
			};

			HawkCompare.addItem = function (itemVal) {
				var index = HawkCompare.countItems();
				window['hawktocompare'][index] = itemVal;
				if (HawkCompare.countItems() != 0) {
					$(".hawk-subControls.clearfix").css("display", "block");
				}
			};

			HawkCompare.getImage = function (itemVal) {
				// sets up query and cache
				var compareQuery = HawkSearch.BaseUrl + "/default.aspx?fn=ajax&F=GetItemImageToCompare&ItemId=" + itemVal;
				var cacheResp = window[compareQuery];
				// check for cache; process and output ajax query
				if (cacheResp) {
					HawkCompare.addImage(cacheResp.Image);
				} else {
					$.ajax({
						type: "GET",
						contentType: "application/json; charset=utf-8",
						url: compareQuery,
						dataType: 'jsonp',
						data: "",
						async: false,
						success: function (json) {
							window[compareQuery] = json;
							HawkCompare.addImage(json.Image);
						}
					});
				};
			};

			HawkCompare.addImage = function (htmlLi) {
				$(".hawk-compareList>ul").each(function () {
					$(this).find("li").each(function () {
						if ($(this).html() == "" || $(this).html() == "&nbsp;") {
							$(this).html(htmlLi);
							return false;
						}
						return true;
					});
				});
			};

			HawkCompare.countItems = function () {
				return window['hawktocompare'].length;
			};

			HawkCompare.reload = function () {
				$.each(window['hawktocompare'], function (i, value) {
					HawkCompare.getImage(value);
					$("#chkItemCompare" + value).attr("checked", true);
				});
			};

			HawkCompare.removeItem = function (itemVal) {
				$(".hawk-compareList>ul").each(function () {
					var cItem = $(this).find("a#" + itemVal).parent();
					cItem.parent().append("<li>&nbsp;</li>");
					cItem.remove();
				});
				$("#chkItemCompare" + itemVal).attr("checked", false);

				var index = window['hawktocompare'].indexOf(itemVal);
				window['hawktocompare'].splice(index, 1);

				if (HawkCompare.countItems() == 0) {
					$(".hawk-subControls.clearfix").css("display", "none");
				}

			};

		}(window.HawkCompare = window.HawkCompare || {}, jQuery));

		// END Namespaced HawkSearch block.

		HawkSearch.loadRecommender = function () {
			var recommender = new HawkSearch.Recommender(HawkSearch.jQuery);
		}

		$(document).ready(function () {
			HawkSearch.loadRecommender();
			//HawkSearch.Tracking.writeSearch(); // DISABLED due to duplicate tracking
			HawkSearch.regTracking();

			$("#divSmartBug").delegate(".bugExplain", "click", function () {
				$("#hdnhawkadv").val($(this).attr("href"));
				HawkSearch.refreshUrl(null, true);
				return false;
			});

			// load items to compare
			var items = decodeURIComponent(HawkSearch.getHashOrQueryVariable("items"));
			if (items != "") {
				window['hawktocompare'] = items.split(",");
				if ($.isFunction(window.HawkCompare.reload)) HawkCompare.reload();
			} else {
				window['hawktocompare'] = new Array();
			}

			// bind the click event to the anchor tags
			$("#hawkfacets").on("click", ".slider-clear, .hawk-facetFilters a", function (event) {

				// clear the current page
				$("#hdnhawkpg").val("");
				var options = $(this).data().options;
				var ul = $(this).parents("ul.hawk-facetFilters");
				if (ul.hasClass("singlefacet")) {
					ul.find(".hawkFacet-active a").each(function () {
						var opt = $(this).data().options;
						if (options.value !== opt.value) {
							$(this).parent().removeClass("hawkFacet-active");
						}
					});
				}
				//if (window.matchMedia("(min-width: 769px)").matches) {
				if (typeof (options.hash) !== "undefined") {
					if (HawkSearch.disableAjax()) {
						window.location = $(this).attr("href");
					} else {
						window.history.pushState({}, {}, "?" + options.hash);
					}
				} else {
					HawkSearch.refreshUrl(event);
				}
				//}

				return false;
			});

			if (!HawkSearch.disableAjax()) {
				var newHash = window.location.search.substring(1);
				if (newHash === "" || (window.location.search.substring(1) !== "" && window.location.href.indexOf("#") > -1)) newHash = HawkSearch.getHash();
				if (window.location.search.substring(1) !== newHash) {
					window.history.pushState({}, {}, "?" + newHash);
				}
			}

			// hawk pagination
			$("#hawktoppager, #hawkbottompager").on("click", ".hawk-pageLink", function (e) {
				e.preventDefault();
				if ($(this).hasClass("disabled") || $("#hdnhawkpg").val() === $(this).attr("page")) return false;

				$("#hdnhawkpg").val($(this).attr("page"));
				HawkSearch.refreshUrl();
				return false;
			});

			// hawk sorting
			$("#hawktoppager, #hawkbottompager").on("change", ".hawksortby", function (e) {
				// clear the current page
				$("#hdnhawkpg").val("");

				$("#hdnhawksortby").val($(this).val());
				$(".hawksortby").val($(this).val());

				HawkSearch.refreshUrl(e);
				return false;
			});

			// hawk change per page
			$("#hawktoppager, #hawkbottompager").on("change", ".hawkmpp", function (event) {
				// clear the current page
				$("#hdnhawkpg").val("");

				$("#hdnhawkmpp").val($(this).val());
				$(".hawkmpp").val($(this).val());

				HawkSearch.refreshUrl(event);
				return false;
			});

			var hawkmpp = $(".hawkmpp");
			if (hawkmpp.length > 0 && hawkmpp.eq(0).val() !== "" && $("#hdnhawkmpp").val() === "") {
				$("#hdnhawkmpp").val(hawkmpp.eq(0).val());
				hawkmpp.val($("#hdnhawkmpp").val());
			}

			$("#hawkfacets").on("click", ".hawk-selectedGroup a", function (e) {
				e.preventDefault();
				if (HawkSearch.disableAjax()) {
					window.location = $(this).attr("href");
				} else {
					var options = $(this).data().options;
					if (window.location.hash == options.hash) {
						window.location.hash = " ";
					} else {
						var options = $(this).data().options;
						if (window.location.hash == options.hash) {
							window.history.pushState({}, {}, window.location.pathname);
						} else {
							var split = options.hash.split("&");
							var newHash = "";
							for (var i = 0; i < split.length; i++) {
								if (split[i].indexOf("hawkfeatured") < 0
									&& split[i].indexOf("storeid") < 0
									&& split[i].indexOf("ismobile") < 0
									&& split[i].indexOf("hawksource") < 0
									&& split[i].indexOf("mpp=60") < 0
									&& split[i].indexOf("hawktracking") < 0) {
									if (newHash.length > 0) newHash += "&";
									newHash += split[i];
								}
							}
							window.history.pushState({}, {}, "?" + newHash);
						}
					}

				}
				return false;
			});

			$("#hawktoppager, #hawkbottompager").on("click", ".btnCompareItems", function () {
				if (HawkCompare.countItems() < 2) {
					alert('You should select at least 2 items');
					return false;
				} else {
					$("#hdnhawkcompare").val(window['hawktocompare'].join(","));
					HawkCompare.process();
				}
				return true;
			});

			$("#hawkitemlist").on("change", "input.ckbItemCompare", function () {
				if ($(this).is(':checked')) {
					if (HawkCompare.countItems() >= 5) {
						alert('You can compare up to 5 items');
						$(this).attr('checked', false);
						return false;
					} else {
						HawkCompare.getImage($(this).val());
						HawkCompare.addItem($(this).val());
					}
				} else {
					HawkCompare.removeItem($(this).val());
				}
				return true;
			});

			$("#hawkfacets").on("click", ".hawk-searchWithinButton", function (event) {
				$("#hdnhawkpg").val("");
				HawkSearch.refreshUrl(event);
			});

			if (HawkSearch.GetRecentSearches !== undefined) {
				HawkSearch.GetRecentSearches();
			}

			$(window).on("debouncedresize", function (event) {
				$("#hawkitemlist .itemWrapper").css("min-height", 0);
				$("#hawkbannertop .itemWrapper").css("min-height", 0);
				//HawkSearch.normalizeHeights();
				log("resize");
			});

			HawkSearch.BindFacetTooltip();

			if ($(".hawk-facetScollingContainer").length) {
				HawkSearch.FacetContainerScrollable();
			}

			HawkSearch.BindBackToTop();

		});



		$.expr[':'].containsNoCase = function (a, i, m) {
			var regex = /(.*?)\s\(\d+?\)/;
			var textNode = a.textContent || a.innerText || "";
			var matches = textNode.match(regex);
			if (matches == null) {
				return null;
			}

			return (matches[1]).toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
		};

		$.fn.filterThatList = function (options) {
			// if there are no passed options create an empty options object
			if (options === undefined || options === null) {
				options = {};
			}
			;

			// set up default options
			var defaults = {
				searchTarget: $(this) // the search input
			};

			return this.each(function () {
				// merge passed options with default options to create settings
				var settings = $.extend(defaults, options);

				settings.searchTarget.change(function () {
					// get the value of the input which is used to filter against
					var filter = $(this).val();
					var searchList = settings.list;
					var isNestedFacet = settings.list.hasClass("hawk-nestedfacet");
					//when nested facet prepare flat facet
					if (isNestedFacet) {
						var flatUlId = settings.list.attr("id") + "_flat";
						if ($("#" + flatUlId).length == 0) {
							var searchList = $(settings.list[0].cloneNode(false));
							searchList.removeClass("hawk-navTruncateList");
							searchList.addClass("hawk-scrollList");
							searchList.attr("id", flatUlId);
							searchList.appendTo(settings.list.parent());

							$(settings.list).find("li").each(function () {
								var pathArr = [];
								$(this).parentsUntil("#" + settings.list.attr("id"), "li").each(function () {
									var text = $($($(this).children("a")).children("span").contents()[0]).text();
									text = text.trim();
									pathArr.unshift(text);
								});

								var li = $("<li>");
								if ($(this).hasClass("hawkFacet-active")) {
									li.addClass("hawkFacet-active");
								}

								li.appendTo(searchList);
								var anchor = $(this).children("a").clone();
								if (pathArr.length > 0) {
									var textSpan = anchor.children("span")
									var spanCount = textSpan.children(".hawk-facetCount").remove()
									pathArr.push(textSpan.text());
									textSpan.html(pathArr.join(" &raquo; "));
									textSpan.append(spanCount);
								}

								anchor.appendTo(li);
							});
							var liHeight = searchList.children("li").first().outerHeight();
							//set search list for max 20 elements
							searchList.css("max-height", (liHeight * 20) + "px");
							settings.list.hide();
						}
						else {
							searchList = $("#" + flatUlId);
							searchList.show();
							settings.list.hide();
						}
					}
					var noResults = ("<li><span>No Results Found</span></li>");

					if (filter) {
						searchList
							// hide items that do not match input filter
							.find("li:not(:containsNoCase(" + filter + "))").hide()
							// show items that match input filter
							.end().find("li:containsNoCase(" + filter + ")").show();

						var items = searchList.find("li:containsNoCase(" + filter + ")");

						// nothing matches filter
						// add no results found
						if (items.length == 0) {
							var item = $(noResults);
							searchList.prepend(item);
							return;
						}

						//check if more results
						var options = settings.list.data().options;
						var moreItems = items.filter(function (index) {
							return index >= options.cutoff;
						});
						moreItems.hide();

						//if no more results
						if (moreItems.length == 0) {
							return;
						}

						//otherwise
						//remove no results
						items.find(":contains('No Results Found')").remove();

						if (moreItems) {
							//add more button and handle it's click event
							var more = settings.list.find("li.hawk-navMore");
							more.off("click").find("span").text("(+) Show " + moreItems.length + " More");
							more.show();

							more.on("click", function (event) {
								var moreTrigger = $(this);
								if ($(this).hasClass("hawk-navMoreActive")) {
									searchList
										// hide items that do not match input filter
										.find("li:not(:containsNoCase(" + filter + "))").hide()
										// show items that match input filter
										.end().find("li:containsNoCase(" + filter + ")").show();

									items = searchList.find("li:containsNoCase(" + filter + ")");

									moreItems = items.filter(function (index) {
										return index >= options.cutoff;
									});
									moreItems.hide();

									moreTrigger.find("span").text("(+) Show " + moreItems.length + " More");
									moreTrigger.removeClass("hawk-navMoreActive");
									window["hawkexpfacet_" + searchList.attr("id")] = null;
									moreTrigger.show();
								} else {
									searchList
										// hide items that do not match input filter
										.find("li:not(:containsNoCase(" + filter + "))").hide()
										// show items that match input filter
										.end().find("li:containsNoCase(" + filter + ")").show();

									items = searchList.find("li:containsNoCase(" + filter + ")");

									// nothing matches filter
									if (items.length == 0) {
										var item = $(noResults);
										searchList.prepend(item);
										return;
									}
									moreTrigger.addClass("hawk-navMoreActive").find("span").text(options.lessText);
									moreTrigger.show();
									window["hawkexpfacet_" + searchList.attr("id")] = true;
								};
							});

						}
						//no filter
					} else {
						//remove no results option
						settings.list.find(":contains('No Results Found')").remove();

						// if nothing is entered display all items in list
						if (isNestedFacet) {
							searchList.hide();
							settings.list.show();
						}
						else {
							if (settings.list.hasClass("hawk-navTruncateList")) {
								var wasExpanded = settings.list.find("li.hawk-navMore > span").hasClass("hawk-navMoreActive");

								if (wasExpanded) {
									settings.list.find("li").show();
								}
								else {
									var options = settings.list.data().options;
									var items = settings.list.find("li:not(.hawk-navMore)");

									items.each(function (i, el) {
										if (i < options.cutoff) {
											$(this).show();
										} else {
											$(this).hide();
										}
									});


									//check if more results
									var options = settings.list.data().options;
									var moreItems = items.filter(function (index) {
										return index >= options.cutoff;
									});
									moreItems.hide();

									//if no more results
									if (moreItems.length == 0) {
										return;
									}

									if (moreItems) {
										var more = settings.list.find("li.hawk-navMore");
										more.off("click").find("span").text(options.moreText);
										more.show();

										more.on("click", function (event) {
											var moreTrigger = $(this);
											if ($(this).hasClass("hawk-navMoreActive")) {
												moreTrigger.hide();
												moreTrigger.removeClass("hawk-navMoreActive").find("span").text(options.moreText);
												window["hawkexpfacet_" + searchList.attr("id")] = null;
												moreTrigger.show();
											} else {
												moreTrigger.addClass("hawk-navMoreActive").find("span").text(options.lessText);
												window["hawkexpfacet_" + searchList.attr("id")] = true;
												moreTrigger.show();
											};
										});
									}

								}
							} else {
								settings.list.find("li").show();
							}
						}
					}
				}).keyup(function () {
					//trigger above actions at every keyup
					$(this).change();
				});

			});
		};

		/************************/
		/* Custom Plugins Below */
		/************************/

		//requireJS, these are not the plugins you are looking for
		//TRUST ME. THIS IS GOOD. PLEASE DON'T REMOVE THIS.
		var define = undefined;


		/*!
         * imagesLoaded PACKAGED v3.1.8
         * JavaScript is all like "You images are done yet or what?"
         * MIT License
         *
         * Hawk Note: Had to romove this line from the plguin to keep our encapsulation. var $ = window.jQuery;
         *
         */
		//(function () { function e() { } function i(e, t) { var n = e.length; while (n--) { if (e[n].listener === t) { return n } } return -1 } function s(e) { return function () { return this[e].apply(this, arguments) } } var t = e.prototype; var n = this; var r = n.EventEmitter; t.getListeners = function (t) { var n = this._getEvents(); var r; var i; if (typeof t === "object") { r = {}; for (i in n) { if (n.hasOwnProperty(i) && t.test(i)) { r[i] = n[i] } } } else { r = n[t] || (n[t] = []) } return r }; t.flattenListeners = function (t) { var n = []; var r; for (r = 0; r < t.length; r += 1) { n.push(t[r].listener) } return n }; t.getListenersAsObject = function (t) { var n = this.getListeners(t); var r; if (n instanceof Array) { r = {}; r[t] = n } return r || n }; t.addListener = function (t, n) { var r = this.getListenersAsObject(t); var s = typeof n === "object"; var o; for (o in r) { if (r.hasOwnProperty(o) && i(r[o], n) === -1) { r[o].push(s ? n : { listener: n, once: false }) } } return this }; t.on = s("addListener"); t.addOnceListener = function (t, n) { return this.addListener(t, { listener: n, once: true }) }; t.once = s("addOnceListener"); t.defineEvent = function (t) { this.getListeners(t); return this }; t.defineEvents = function (t) { for (var n = 0; n < t.length; n += 1) { this.defineEvent(t[n]) } return this }; t.removeListener = function (t, n) { var r = this.getListenersAsObject(t); var s; var o; for (o in r) { if (r.hasOwnProperty(o)) { s = i(r[o], n); if (s !== -1) { r[o].splice(s, 1) } } } return this }; t.off = s("removeListener"); t.addListeners = function (t, n) { return this.manipulateListeners(false, t, n) }; t.removeListeners = function (t, n) { return this.manipulateListeners(true, t, n) }; t.manipulateListeners = function (t, n, r) { var i; var s; var o = t ? this.removeListener : this.addListener; var u = t ? this.removeListeners : this.addListeners; if (typeof n === "object" && !(n instanceof RegExp)) { for (i in n) { if (n.hasOwnProperty(i) && (s = n[i])) { if (typeof s === "function") { o.call(this, i, s) } else { u.call(this, i, s) } } } } else { i = r.length; while (i--) { o.call(this, n, r[i]) } } return this }; t.removeEvent = function (t) { var n = typeof t; var r = this._getEvents(); var i; if (n === "string") { delete r[t] } else if (n === "object") { for (i in r) { if (r.hasOwnProperty(i) && t.test(i)) { delete r[i] } } } else { delete this._events } return this }; t.removeAllListeners = s("removeEvent"); t.emitEvent = function (t, n) { var r = this.getListenersAsObject(t); var i; var s; var o; var u; for (o in r) { if (r.hasOwnProperty(o)) { s = r[o].length; while (s--) { i = r[o][s]; if (i.once === true) { this.removeListener(t, i.listener) } u = i.listener.apply(this, n || []); if (u === this._getOnceReturnValue()) { this.removeListener(t, i.listener) } } } } return this }; t.trigger = s("emitEvent"); t.emit = function (t) { var n = Array.prototype.slice.call(arguments, 1); return this.emitEvent(t, n) }; t.setOnceReturnValue = function (t) { this._onceReturnValue = t; return this }; t._getOnceReturnValue = function () { if (this.hasOwnProperty("_onceReturnValue")) { return this._onceReturnValue } else { return true } }; t._getEvents = function () { return this._events || (this._events = {}) }; e.noConflict = function () { n.EventEmitter = r; return e }; if (typeof define === "function" && define.amd) { define("eventEmitter/EventEmitter", [], function () { return e }) } else if (typeof module === "object" && module.exports) { module.exports = e } else { this.EventEmitter = e } }).call(this); (function (e) { function r(t) { var n = e.event; n.target = n.target || n.srcElement || t; return n } var t = document.documentElement; var n = function () { }; if (t.addEventListener) { n = function (e, t, n) { e.addEventListener(t, n, false) } } else if (t.attachEvent) { n = function (e, t, n) { e[t + n] = n.handleEvent ? function () { var t = r(e); n.handleEvent.call(n, t) } : function () { var t = r(e); n.call(e, t) }; e.attachEvent("on" + t, e[t + n]) } } var i = function () { }; if (t.removeEventListener) { i = function (e, t, n) { e.removeEventListener(t, n, false) } } else if (t.detachEvent) { i = function (e, t, n) { e.detachEvent("on" + t, e[t + n]); try { delete e[t + n] } catch (r) { e[t + n] = undefined } } } var s = { bind: n, unbind: i }; if (typeof define === "function" && define.amd) { define("eventie/eventie", s) } else { e.eventie = s } })(this); (function (e, t) { if (typeof define === "function" && define.amd) { define(["eventEmitter/EventEmitter", "eventie/eventie"], function (n, r) { return t(e, n, r) }) } else if (typeof exports === "object") { module.exports = t(e, require("wolfy87-eventemitter"), require("eventie")) } else { e.imagesLoaded = t(e, e.EventEmitter, e.eventie) } })(window, function (t, n, r) { function o(e, t) { for (var n in t) { e[n] = t[n] } return e } function a(e) { return u.call(e) === "[object Array]" } function f(e) { var t = []; if (a(e)) { t = e } else if (typeof e.length === "number") { for (var n = 0, r = e.length; n < r; n++) { t.push(e[n]) } } else { t.push(e) } return t } function l(e, t, n) { if (!(this instanceof l)) { return new l(e, t) } if (typeof e === "string") { e = document.querySelectorAll(e) } this.elements = f(e); this.options = o({}, this.options); if (typeof t === "function") { n = t } else { o(this.options, t) } if (n) { this.on("always", n) } this.getImages(); if ($) { this.jqDeferred = new $.Deferred } var r = this; setTimeout(function () { r.check() }) } function c(e) { this.img = e } function p(e) { this.src = e; h[e] = this } var i = t.console; var s = typeof i !== "undefined"; var u = Object.prototype.toString; l.prototype = new n; l.prototype.options = {}; l.prototype.getImages = function () { this.images = []; for (var e = 0, t = this.elements.length; e < t; e++) { var n = this.elements[e]; if (n.nodeName === "IMG") { this.addImage(n) } var r = n.nodeType; if (!r || !(r === 1 || r === 9 || r === 11)) { continue } var i = n.querySelectorAll("img"); for (var s = 0, o = i.length; s < o; s++) { var u = i[s]; this.addImage(u) } } }; l.prototype.addImage = function (e) { var t = new c(e); this.images.push(t) }; l.prototype.check = function () { function r(r, o) { if (e.options.debug && s) { i.log("confirm", r, o) } e.progress(r); t++; if (t === n) { e.complete() } return true } var e = this; var t = 0; var n = this.images.length; this.hasAnyBroken = false; if (!n) { this.complete(); return } for (var o = 0; o < n; o++) { var u = this.images[o]; u.on("confirm", r); u.check() } }; l.prototype.progress = function (e) { this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded; var t = this; setTimeout(function () { t.emit("progress", t, e); if (t.jqDeferred && t.jqDeferred.notify) { t.jqDeferred.notify(t, e) } }) }; l.prototype.complete = function () { var e = this.hasAnyBroken ? "fail" : "done"; this.isComplete = true; var t = this; setTimeout(function () { t.emit(e, t); t.emit("always", t); if (t.jqDeferred) { var n = t.hasAnyBroken ? "reject" : "resolve"; t.jqDeferred[n](t) } }) }; if ($) { $.fn.imagesLoaded = function (e, t) { var n = new l(this, e, t); return n.jqDeferred.promise($(this)) } } c.prototype = new n; c.prototype.check = function () { var e = h[this.img.src] || new p(this.img.src); if (e.isConfirmed) { this.confirm(e.isLoaded, "cached was confirmed"); return } if (this.img.complete && this.img.naturalWidth !== undefined) { this.confirm(this.img.naturalWidth !== 0, "naturalWidth"); return } var t = this; e.on("confirm", function (e, n) { t.confirm(e.isLoaded, n); return true }); e.check() }; c.prototype.confirm = function (e, t) { this.isLoaded = e; this.emit("confirm", this, t) }; var h = {}; p.prototype = new n; p.prototype.check = function () { if (this.isChecked) { return } var e = new Image; r.bind(e, "load", this); r.bind(e, "error", this); e.src = this.src; this.isChecked = true }; p.prototype.handleEvent = function (e) { var t = "on" + e.type; if (this[t]) { this[t](e) } }; p.prototype.onload = function (e) { this.confirm(true, "onload"); this.unbindProxyEvents(e) }; p.prototype.onerror = function (e) { this.confirm(false, "onerror"); this.unbindProxyEvents(e) }; p.prototype.confirm = function (e, t) { this.isConfirmed = true; this.isLoaded = e; this.emit("confirm", this, t) }; p.prototype.unbindProxyEvents = function (e) { r.unbind(e.target, "load", this); r.unbind(e.target, "error", this) }; return l })


		/*
        * jQuery cookie
        */
		HawkSearch.jQuery.cookie = function (name, value, options) {
			if (typeof value != 'undefined') { // name and value given, set cookie
				options = options || {
				};
				if (value === null) {
					value = '';
					options.expires = -1;
				}
				var expires = '';
				if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
					var date;
					if (typeof options.expires == 'number') {
						date = new Date();
						date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
					} else {
						date = options.expires;
					}
					expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
				}
				// CAUTION: Needed to parenthesize options.path and options.domain
				// in the following expressions, otherwise they evaluate to undefined
				// in the packed version for some reason...
				var path = options.path ? '; path=' + (options.path) : '';
				var domain = options.domain ? '; domain=' + (options.domain) : '';
				var secure = options.secure ? '; secure' : '';
				document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
			} else { // only name given, get cookie
				var cookieValue = null;
				if (document.cookie && document.cookie != '') {
					var cookies = document.cookie.split(';');
					for (var i = 0; i < cookies.length; i++) {
						var cookie = $.trim(cookies[i]);
						// Does this cookie string begin with the name we want?
						if (cookie.substring(0, name.length + 1) == (name + '=')) {
							cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
							break;
						}
					}
				}
				return cookieValue;
			}
		};

		// if bootstrap3 is already on the site, do not load this bootstrap.
		if (!bootstrap3_enabled) {
			log("Loading: local bootstrap");

			/**
            * Bootstrap.js by @fat & @mdo
            * plugins: bootstrap-modal.js, bootstrap-tooltip.js, bootstrap-popover.js
            * Copyright 2013 Twitter, Inc.
            * http://www.apache.org/licenses/LICENSE-2.0.txt
            */
			// !function (a) { var b = function (b, c) { this.options = c, this.$element = a(b).delegate('[data-dismiss="modal"]', "click.dismiss.modal", a.proxy(this.hide, this)), this.options.remote && this.$element.find(".modal-body").load(this.options.remote) }; b.prototype = { constructor: b, toggle: function () { return this[this.isShown ? "hide" : "show"]() }, show: function () { var b = this, c = a.Event("show"); this.$element.trigger(c); if (this.isShown || c.isDefaultPrevented()) return; this.isShown = !0, this.escape(), this.backdrop(function () { var c = a.support.transition && b.$element.hasClass("fade"); b.$element.parent().length || b.$element.appendTo(document.body), b.$element.show(), c && b.$element[0].offsetWidth, b.$element.addClass("in").attr("aria-hidden", !1), b.enforceFocus(), c ? b.$element.one(a.support.transition.end, function () { b.$element.focus().trigger("shown") }) : b.$element.focus().trigger("shown") }) }, hide: function (b) { b && b.preventDefault(); var c = this; b = a.Event("hide"), this.$element.trigger(b); if (!this.isShown || b.isDefaultPrevented()) return; this.isShown = !1, this.escape(), a(document).off("focusin.modal"), this.$element.removeClass("in").attr("aria-hidden", !0), a.support.transition && this.$element.hasClass("fade") ? this.hideWithTransition() : this.hidenniskirkdal() }, enforceFocus: function () { var b = this; a(document).on("focusin.modal", function (a) { b.$element[0] !== a.target && !b.$element.has(a.target).length && b.$element.focus() }) }, escape: function () { var a = this; this.isShown && this.options.keyboard ? this.$element.on("keyup.dismiss.modal", function (b) { b.which == 27 && a.hide() }) : this.isShown || this.$element.off("keyup.dismiss.modal") }, hideWithTransition: function () { var b = this, c = setTimeout(function () { b.$element.off(a.support.transition.end), b.hidenniskirkdal() }, 500); this.$element.one(a.support.transition.end, function () { clearTimeout(c), b.hidenniskirkdal() }) }, hidenniskirkdal: function () { var a = this; this.$element.hide(), this.backdrop(function () { a.removeBackdrop(), a.$element.trigger("hidden") }) }, removeBackdrop: function () { this.$backdrop && this.$backdrop.remove(), this.$backdrop = null }, backdrop: function (b) { var c = this, d = this.$element.hasClass("fade") ? "fade" : ""; if (this.isShown && this.options.backdrop) { var e = a.support.transition && d; this.$backdrop = a('<div class="modal-backdrop ' + d + '" />').appendTo(document.body), this.$backdrop.click(this.options.backdrop == "static" ? a.proxy(this.$element[0].focus, this.$element[0]) : a.proxy(this.hide, this)), e && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"); if (!b) return; e ? this.$backdrop.one(a.support.transition.end, b) : b() } else !this.isShown && this.$backdrop ? (this.$backdrop.removeClass("in"), a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one(a.support.transition.end, b) : b()) : b && b() } }; var c = a.fn.modal; a.fn.modal = function (c) { return this.each(function () { var d = a(this), e = d.data("modal"), f = a.extend({}, a.fn.modal.defaults, d.data(), typeof c == "object" && c); e || d.data("modal", e = new b(this, f)), typeof c == "string" ? e[c]() : f.show && e.show() }) }, a.fn.modal.defaults = { backdrop: !0, keyboard: !0, show: !0 }, a.fn.modal.Constructor = b, a.fn.modal.noConflict = function () { return a.fn.modal = c, this }, a(document).on("click.modal.data-api", '[data-toggle="modal"]', function (b) { var c = a(this), d = c.attr("href"), e = a(c.attr("data-target") || d && d.replace(/.*(?=#[^\s]+$)/, "")), f = e.data("modal") ? "toggle" : a.extend({ remote: !/#/.test(d) && d }, e.data(), c.data()); b.preventDefault(), e.modal(f).one("hide", function () { c.focus() }) }) }(jQuery), !function (a) { var b = function (a, b) { this.init("tooltip", a, b) }; b.prototype = { constructor: b, init: function (b, c, d) { var e, f, g, h, i; this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.enabled = !0, g = this.options.trigger.split(" "); for (i = g.length; i--;) h = g[i], h == "click" ? this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this)) : h != "manual" && (e = h == "hover" ? "mouseenter" : "focus", f = h == "hover" ? "mouseleave" : "blur", this.$element.on(e + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(f + "." + this.type, this.options.selector, a.proxy(this.leave, this))); this.options.selector ? this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle() }, getOptions: function (b) { return b = a.extend({}, a.fn[this.type].defaults, this.$element.data(), b), b.delay && typeof b.delay == "number" && (b.delay = { show: b.delay, hide: b.delay }), b }, enter: function (b) { var c = a.fn[this.type].defaults, d = {}, e; this._options && a.each(this._options, function (a, b) { c[a] != b && (d[a] = b) }, this), e = a(b.currentTarget)[this.type](d).data(this.type); if (!e.options.delay || !e.options.delay.show) return e.show(); clearTimeout(this.timeout), e.hoverState = "in", this.timeout = setTimeout(function () { e.hoverState == "in" && e.show() }, e.options.delay.show) }, leave: function (b) { var c = a(b.currentTarget)[this.type](this._options).data(this.type); this.timeout && clearTimeout(this.timeout); if (!c.options.delay || !c.options.delay.hide) return c.hide(); c.hoverState = "out", this.timeout = setTimeout(function () { c.hoverState == "out" && c.hide() }, c.options.delay.hide) }, show: function () { var b, c, d, e, f, g, h = a.Event("show"); if (this.hasContent() && this.enabled) { this.$element.trigger(h); if (h.isDefaultPrevented()) return; b = this.tip(), this.setContent(), this.options.animation && b.addClass("fade"), f = typeof this.options.placement == "function" ? this.options.placement.call(this, b[0], this.$element[0]) : this.options.placement, b.detach().css({ top: 0, left: 0, display: "block" }), this.options.container ? b.appendTo(this.options.container) : b.insertAfter(this.$element), c = this.getPosition(), d = b[0].offsetWidth, e = b[0].offsetHeight; switch (f) { case "bottom": g = { top: c.top + c.height, left: c.left + c.width / 2 - d / 2 }; break; case "top": g = { top: c.top - e, left: c.left + c.width / 2 - d / 2 }; break; case "left": g = { top: c.top + c.height / 2 - e / 2, left: c.left - d }; break; case "right": g = { top: c.top + c.height / 2 - e / 2, left: c.left + c.width } } this.applyPlacement(g, f), this.$element.trigger("shown") } }, applyPlacement: function (a, b) { var c = this.tip(), d = c[0].offsetWidth, e = c[0].offsetHeight, f, g, h, i; c.offset(a).addClass(b).addClass("in"), f = c[0].offsetWidth, g = c[0].offsetHeight, b == "top" && g != e && (a.top = a.top + e - g, i = !0), b == "bottom" || b == "top" ? (h = 0, a.left < 0 && (h = a.left * -2, a.left = 0, c.offset(a), f = c[0].offsetWidth, g = c[0].offsetHeight), this.replaceArrow(h - d + f, f, "left")) : this.replaceArrow(g - e, g, "top"), i && c.offset(a) }, replaceArrow: function (a, b, c) { this.arrow().css(c, a ? 50 * (1 - a / b) + "%" : "") }, setContent: function () { var a = this.tip(), b = this.getTitle(); a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right") }, hide: function () { function e() { var b = setTimeout(function () { c.off(a.support.transition.end).detach() }, 500); c.one(a.support.transition.end, function () { clearTimeout(b), c.detach() }) } var b = this, c = this.tip(), d = a.Event("hide"); this.$element.trigger(d); if (d.isDefaultPrevented()) return; return c.removeClass("in"), a.support.transition && this.$tip.hasClass("fade") ? e() : c.detach(), this.$element.trigger("hidden"), this }, fixTitle: function () { var a = this.$element; (a.attr("title") || typeof a.attr("data-original-title") != "string") && a.attr("data-original-title", a.attr("title") || "").attr("title", "") }, hasContent: function () { return this.getTitle() }, getPosition: function () { var b = this.$element[0]; return a.extend({}, typeof b.getBoundingClientRect == "function" ? b.getBoundingClientRect() : { width: b.offsetWidth, height: b.offsetHeight }, this.$element.offset()) }, getTitle: function () { var a, b = this.$element, c = this.options; return a = b.attr("data-original-title") || (typeof c.title == "function" ? c.title.call(b[0]) : c.title), a }, tip: function () { return this.$tip = this.$tip || a(this.options.template) }, arrow: function () { return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow") }, validate: function () { this.$element[0].parentNode || (this.hide(), this.$element = null, this.options = null) }, enable: function () { this.enabled = !0 }, disable: function () { this.enabled = !1 }, toggleEnabled: function () { this.enabled = !this.enabled }, toggle: function (b) { var c = b ? a(b.currentTarget)[this.type](this._options).data(this.type) : this; c.tip().hasClass("in") ? c.hide() : c.show() }, destroy: function () { this.hide().$element.off("." + this.type).removeData(this.type) } }; var c = a.fn.tooltip; a.fn.tooltip = function (c) { return this.each(function () { var d = a(this), e = d.data("tooltip"), f = typeof c == "object" && c; e || d.data("tooltip", e = new b(this, f)), typeof c == "string" && e[c]() }) }, a.fn.tooltip.Constructor = b, a.fn.tooltip.defaults = { animation: !0, placement: "top", selector: !1, template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: "hover focus", title: "", delay: 0, html: !1, container: !1 }, a.fn.tooltip.noConflict = function () { return a.fn.tooltip = c, this } }(jQuery), !function (e) { "use strict"; var t = function (t, n) { this.$element = e(t), this.options = e.extend({}, e.fn.collapse.defaults, n), this.options.parent && (this.$parent = e(this.options.parent)), this.options.toggle && this.toggle() }; t.prototype = { constructor: t, dimension: function () { var e = this.$element.hasClass("width"); return e ? "width" : "height" }, show: function () { var t, n, r, i; if (this.transitioning || this.$element.hasClass("in")) return; t = this.dimension(), n = e.camelCase(["scroll", t].join("-")), r = this.$parent && this.$parent.find("> .accordion-group > .in"); if (r && r.length) { i = r.data("collapse"); if (i && i.transitioning) return; r.collapse("hide"), i || r.data("collapse", null) } this.$element[t](0), this.transition("addClass", e.Event("show"), "shown"), e.support.transition && this.$element[t](this.$element[0][n]) }, hide: function () { var t; if (this.transitioning || !this.$element.hasClass("in")) return; t = this.dimension(), this.reset(this.$element[t]()), this.transition("removeClass", e.Event("hide"), "hidden"), this.$element[t](0) }, reset: function (e) { var t = this.dimension(); return this.$element.removeClass("collapse")[t](e || "auto")[0].offsetWidth, this.$element[e !== null ? "addClass" : "removeClass"]("collapse"), this }, transition: function (t, n, r) { var i = this, s = function () { n.type == "show" && i.reset(), i.transitioning = 0, i.$element.trigger(r) }; this.$element.trigger(n); if (n.isDefaultPrevented()) return; this.transitioning = 1, this.$element[t]("in"), e.support.transition && this.$element.hasClass("collapse") ? this.$element.one(e.support.transition.end, s) : s() }, toggle: function () { this[this.$element.hasClass("in") ? "hide" : "show"]() } }; var n = e.fn.collapse; e.fn.collapse = function (n) { return this.each(function () { var r = e(this), i = r.data("collapse"), s = e.extend({}, e.fn.collapse.defaults, r.data(), typeof n == "object" && n); i || r.data("collapse", i = new t(this, s)), typeof n == "string" && i[n]() }) }, e.fn.collapse.defaults = { toggle: !0 }, e.fn.collapse.Constructor = t, e.fn.collapse.noConflict = function () { return e.fn.collapse = n, this }, e(document).on("click.collapse.data-api", "[data-toggle=collapse]", function (t) { var n = e(this), r, i = n.attr("data-target") || t.preventDefault() || (r = n.attr("href")) && r.replace(/.*(?=#[^\s]+$)/, ""), s = e(i).data("collapse") ? "toggle" : n.data(); n[e(i).hasClass("in") ? "addClass" : "removeClass"]("collapsed"), e(i).collapse(s) }) }(jQuery), !function (a) { var b = function (a, b) { this.init("popover", a, b) }; b.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype, { constructor: b, setContent: function () { var a = this.tip(), b = this.getTitle(), c = this.getContent(); a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content")[this.options.html ? "html" : "text"](c), a.removeClass("fade top bottom left right in") }, hasContent: function () { return this.getTitle() || this.getContent() }, getContent: function () { var a, b = this.$element, c = this.options; return a = (typeof c.content == "function" ? c.content.call(b[0]) : c.content) || b.attr("data-content"), a }, tip: function () { return this.$tip || (this.$tip = a(this.options.template)), this.$tip }, destroy: function () { this.hide().$element.off("." + this.type).removeData(this.type) } }); var c = a.fn.popover; a.fn.popover = function (c) { return this.each(function () { var d = a(this), e = d.data("popover"), f = typeof c == "object" && c; e || d.data("popover", e = new b(this, f)), typeof c == "string" && e[c]() }) }, a.fn.popover.Constructor = b, a.fn.popover.defaults = a.extend({}, a.fn.tooltip.defaults, { placement: "right", trigger: "click", content: "", template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>' }), a.fn.popover.noConflict = function () { return a.fn.popover = c, this } }(HawkSearch.jQuery)
		}

		// END Plugins
	}

}(window.HawkSearchLoader = window.HawkSearchLoader || {}));